/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import CommonAlertsStrip from "../../../../components/_utils/CommonAlertsStrip/index.jsx";
import Chips from "../../../../components/_utils/CommonButtons/Chips";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import PrimaryRightIconFill from "../../../../components/_utils/CommonButtons/PrimaryRightIconFill";
import SecondaryRightIconSmallButton from "../../../../components/_utils/CommonButtons/SecondaryRightIconSmallButton/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import EditCommonPopup from "../../../../components/_utils/CommonPopups/CommonEditPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import SmallPopupWithBulletPoint from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import OwnerAccountItemisedReportComp from "../../../../components/Accounts/OwnerAccount/OwnerAccountConsolidatedLiveStatementComp/index.jsx";
import RemitAccountViewAllPopup from "../../../../components/Accounts/RemitAccount/RemitAccountViewAllPopup/index.jsx";
import Loader from "../../../../components/Loader/Index";
import {
  getAssociatedConsolidatedStatements,
  getAssociatedItemisedStatements,
  remitterAccountApprove,
  remitterAccountArchive,
  remitterAccountDetailsById,
  remitterAccountReject,
  remitterAccountUnarchive,
  remitterAddNewLabel,
  remitterRemoveNewLabel,
  removeUnmatchConsolidatedStatement,
  removeUnmatchItemisedStatement,
  resetConsolidatedAllAccStatementData,
  resetItemisedAllAccStatementData,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll.js";
import TEXT from "../../../../utils/globalText";
import useMultiSelect from "../../../../utils/useMultiSelect.js";
import OwnerAccountConsolidatedBankStatement from "../../OwnerAccount/OwnerAccountConsolidatedBankStatement/index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";

const RemitterAccountDetails = ({
  popup,
  rem_account_id,
  flow,
  closeRemAccountDetailModal,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const bankBarRef = useRef(null);
  const isFirstRender = useRef(true);
  const isFirstLiveRender = useRef(true);
  const location = useLocation();
  const liveBarRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const scrollBankRef = useRef(null);
  const scrollLiveRef = useRef(null);

  const services = useSelector((state) => state.refreshToken.services);
  const {
    remitterAccountDetailsData,
    remitterAccountRejectLoading,
    getAssociatedConsolidatedData,
    getAssociatedConsolidatedLoading,
    getAssociatedItemisedData,
    getAssociatedItemisedLoading,
    remitterAccountViewAllLoading,
  } = useSelector((state) => state.remitterAccount);

  const hasBankStatementPermission = services?.some(
    (service) => service === "VAccountBalance" || service === "Admin",
  );
  const { handleChange, handleSelectAll, handleSingleSelect } =
    useMultiSelect();
  const hasLiveStatementPermission = services?.some(
    (service) => service === "VItemisedStatement" || service === "Admin",
  );

  const hasUnmatchPermission = services?.some(
    (service) => service === "RMapping" || service === "Admin",
  );

  const dropdownOptions =
    window.innerWidth < 1600
      ? PaginationConfiguration.paginationOptions
      : window.innerWidth < GlobalConfiguration.innerWidthMidSize
        ? PaginationConfiguration.paginationOptions
        : PaginationConfiguration.paginationOptions;
  const scrollContainerRef = useRef(null);
  const [loader, setLoader] = useState(true);
  const [selectedChipIndex, setSelectedChipIndex] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [, setMaindata] = useState([]);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [duplicateLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [selectedLiveValue, setSelectedLiveValue] = useState(
    dropdownOptions[0],
  );
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );

  const [editPopup, setEditpopup] = useState(false);
  const [isLiveApiCalled, setIsLiveApiCalled] = useState(false);
  const [isBankApiCalled, setIsBankApiCalled] = useState(false);
  const [livecurrentPage, setLiveCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [bankStatementCount, setBankStatementCount] = useState(
    remitterAccountDetailsData?.mapped_consolidated_statement_entries_count ??
      0,
  );

  const [liveStatementCount, setLiveStatementCount] = useState(
    remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count ??
      0,
  );
  const [pageSize, setPageSize] = useState(
    PaginationConfiguration.paginationSmall,
  );
  const [livepageSize, setLivePageSize] = useState(
    PaginationConfiguration.paginationSmall,
  );
  const [isFocused, setIsFocused] = useState(false);
  const [isService, setIsService] = useState(false);
  const [clickedBtn, setClickedBtn] = useState(null);
  const [copiedField, setCopiedField] = useState("");
  const [rejectAccountLoader, setRejectAccountLoader] = useState(false);
  const [rejectAccount, setRejectAccount] = useState(false);
  const [approveAccount, setApproveAccount] = useState(false);
  const [consolidatedPaginationData, setConsolidatedPaginationData] = useState(
    [],
  );
  const [similarAccountPopup, setSimilarAccountPopup] = useState(false);
  const [livePaginationData, setLivePaginationData] = useState([]);
  const [liveLoader, setLiveLoader] = useState(false);
  const [bankLoader, setBankLoader] = useState(false);
  const [unmatchLoader, setUnmatchLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [unmatchStatementPopup, setUnmatchStatementPopup] = useState(false);
  const [rejectBankStatement, setrejectBankStatement] = useState(false);
  const [unmatchType, setUnmatchType] = useState("");
  const [rejectLiveStatement, setRejectLiveStatement] = useState(false);
  const [viewLiveStatementOpenPop, setViewLivestatementOpenPop] =
    useState(false);
  const [labelName, setLabelName] = useState("");
  const [openLabelSearchPopup, setOpenLabelSearchPopup] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [labelDetails, setLabelDetails] = useState([]);
  const [allLabelsData, setAllLabelsData] = useState([]);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labels, setLabels] = useState([]);
  const [declineReason, setDeclineReason] = useState("");
  const [statementId, setStatementId] = useState([]);
  const [statementLiveConsolidatedId, setStatementLiveConsolidatedId] =
    useState([]);
  const [, setLiveConsolidatedTotalId] = useState([]);
  const [ConsolidatedBankTotalId, setConsolidatedBankTotalId] = useState([]);
  const [animationClass, setAnimationClass] = useState("");
  const [selectCardBank, setselectCardBank] = useState(false);
  const [selectCardLive, setselectCardLive] = useState(false);
  const [archiveAccount, setArchiveAccount] = useState(false);
  const [consolidatedBank, setConsolidatedBank] = useState([]);
  const [consolidatedLive, setConsolidatedLive] = useState([]);
  const [showPopupReject, setshowPopupReject] = useState(false);
  const [unArchiveAccount, setUnArchiveAccount] = useState(false);
  const [ViewAccountDetails, setViewAccountDetails] = useState([]);
  const [viewStatementOpenPop, setViewstatementOpenPop] = useState(false);
  const [index, setIndex] = useState(
    flow === "match_transaction" ||
      location?.state?.flow === "match_transaction"
      ? GlobalConfiguration.lengthCheckZero
      : location?.state?.flow === "live_match_transaction" ||
          flow === "unmatch_transaction"
        ? GlobalConfiguration.lengthCheckOne
        : flow === "more_details"
          ? GlobalConfiguration.lengthCheckFour
          : GlobalConfiguration.lengthCheckZero,
  );
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration?.mobileScreen,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [bankBarHeight, setBankBarHeight] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [liveBarHeight, setLiveBarHeight] = useState(
    GlobalConfiguration.lengthCheckZero,
  );

  const isArchivedAccount =
    remitterAccountDetailsData?.approval_status?.toLowerCase()?.trim() ===
    "archived";

  const isRejectAccount =
    remitterAccountDetailsData?.approval_status?.toLowerCase()?.trim() ===
    "rejected";

  const hasEditPermission =
    services?.includes("REUAccount") && !isArchivedAccount;

  const loadingState =
    rejectAccount ||
    approveAccount ||
    unmatchLoader ||
    showLoader ||
    rejectAccountLoader ||
    unmatchLoader;

  const hasMatchPermission =
    services?.includes("Admin") ||
    (services?.includes("AMapping") && services?.includes("VAccountBalance"));

  const hasLiveMatchPermission =
    services?.includes("Admin") ||
    (services?.includes("AMapping") &&
      services?.includes("VItemisedStatement"));

  const totalRecordCount = Number(
    getAssociatedConsolidatedData?.total_count || 0,
  );

  const effectiveSelectCap =
    totalRecordCount > 0 &&
    totalRecordCount <=
      Number(
        index === GlobalConfiguration.lengthCheckZero
          ? selectedValue
          : selectedLiveValue,
      )
      ? totalRecordCount
      : Number(
          index === GlobalConfiguration.lengthCheckZero
            ? selectedValue
            : selectedLiveValue,
        );

  const isAllSelected =
    consolidatedBank?.length === effectiveSelectCap && effectiveSelectCap > 0;

  const totalRecordCountLive = Number(
    getAssociatedItemisedData?.total_count || 0,
  );

  const effectiveSelectCapLive =
    totalRecordCountLive > 0 &&
    totalRecordCountLive <=
      Number(
        index === GlobalConfiguration.lengthCheckZero
          ? selectedValue
          : selectedLiveValue,
      )
      ? totalRecordCountLive
      : Number(
          index === GlobalConfiguration.lengthCheckZero
            ? selectedValue
            : selectedLiveValue,
        );

  const isAllSelectedLive =
    consolidatedLive?.length === effectiveSelectCapLive &&
    effectiveSelectCapLive > 0;

  const buildAlerts = () => [
    ...(isDuplicate !== undefined
      ? isDuplicate
        ? [
            {
              isLoading: remitterAccountViewAllLoading,
              text: remitterAccountViewAllLoading
                ? "Checking similar accounts"
                : "Similar accounts are found",
              icon: ICONS?.ALERT,
              isDisabled: popup,
              onClick: () => {
                if (popup) {
                  actionRestricted();
                } else {
                  setSimilarAccountPopup(true);
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: duplicateLoading,
            text: "Checking similar accounts",
          },
        ]),
  ];

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id || rem_account_id}`,
    });
  };

  const chipsArray = [
    {
      text: "Account name",
      selected: true,
      disabled: false,
      hoverOption: "blue",
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
      ],
      onClick: () => setSelectedChipIndex(GlobalConfiguration.lengthCheckZero),
    },
  ];

  const handleApply = () => {
    switch (selectedChipIndex) {
      case 0: // Account name, Contact number, Email
        navigate(
          `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/edit_account_details/${id}`,
        );
        break;

      default:
        break;
    }
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const updateAllAccounts = (updatedAccounts) => {
    setViewAccountDetails(updatedAccounts);
  };

  const handleClosePopup = () => {
    setshowPopupReject(false);
    setDeclineReason("");
    // setRejectAccountLoader(false);
    setUnmatchType("");
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleDeclinedDetials = (id) => {
    setClickedBtn("reject");
    setshowPopupReject(true);
  };

  const handleFetchPagination = async () => {
    setBankLoader(true);

    try {
      const response = await dispatch(
        getAssociatedConsolidatedStatements({
          page_no: currentPage,
          page_size: pageSize,
          remitter_account_id: id || rem_account_id,
        }),
      ).unwrap();

      setConsolidatedBankTotalId(
        response?.statement?.map((item) => item?.account_statement_entry_id) ||
          [],
      );

      setConsolidatedPaginationData(response);

      if (response !== undefined) {
        setTimeout(() => {
          setBankLoader(false);
        }, 600);
      }
    } catch (error) {
      CommonToast({
        text: error?.message || "Something went wrong",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } finally {
      setTimeout(() => {
        setBankLoader(false);
      }, IntervalConfiguration.intervalSmall);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      if (flow !== "more_details") {
        handleFetchPagination();
      }

      return () => {
        dispatch(resetConsolidatedAllAccStatementData());
      };
    }

    handleFetchPagination();

    return () => {
      dispatch(resetConsolidatedAllAccStatementData());
    };
  }, [pageSize, currentPage]);

  useEffect(() => {
    setBankStatementCount(
      remitterAccountDetailsData?.mapped_consolidated_statement_entries_count ??
        GlobalConfiguration.lengthCheckZero,
    );

    setLiveStatementCount(
      remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count ??
        GlobalConfiguration.lengthCheckZero,
    );
  }, [remitterAccountDetailsData]);

  const handleLiveFetchPagination = async () => {
    setLiveLoader(true);

    try {
      const response = await dispatch(
        getAssociatedItemisedStatements({
          page_no: livecurrentPage,
          page_size: livepageSize,
          remitter_account_id: id || rem_account_id,
          currentPage: livecurrentPage,
        }),
      );

      setLivePaginationData(response?.payload);
    } catch (error) {
      CommonToast({
        text: error?.message,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } finally {
      setTimeout(() => {
        setLiveLoader(false);
      }, IntervalConfiguration.intervalSmall);
    }
  };

  useEffect(() => {
    if (isFirstLiveRender.current) {
      isFirstLiveRender.current = false;

      if (
        flow !== "more_details" &&
        flow !== "match_transaction" &&
        index === GlobalConfiguration.lengthCheckOne
      ) {
        handleLiveFetchPagination();
      }

      return () => {
        dispatch(resetItemisedAllAccStatementData());
      };
    }

    if (index === GlobalConfiguration.lengthCheckOne) {
      handleLiveFetchPagination();
    }

    return () => {
      dispatch(resetItemisedAllAccStatementData());
    };
  }, [livepageSize, livecurrentPage]);

  const handleFetch = async () => {
    setLoader(true);

    try {
      const data = await dispatch(
        remitterAccountDetailsById({ id: rem_account_id || id }),
      );

      const account = data?.payload?.remitter_accounts?.[0];

      const duplicateFound = account.similar_name === "Y";

      setLiveConsolidatedTotalId(
        account?.mapped_itemised_consolidated_statement_entries?.map(
          (item) => item?.id,
        ),
      );

      setIsDuplicate(duplicateFound);
      setAllLabelsData(data?.payload);
      setMaindata(account);
      setLabelDetails(account?.labels);
    } catch (error) {
      CommonToast({
        text: error?.message,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } finally {
      setLoader(false);
    }
  };

  const handleInputChange = (event) => {
    let value = event?.target?.value;

    value = value.replace(/[^a-zA-Z0-9\s]/g, "");

    value = value.replace(/^\s+/, "");

    value = value.replace(/\s{2,}/g, " ");

    value = value.slice(0, 150);

    setDeclineReason(value);
  };

  const handleCloseModal = () => {
    setUnArchiveAccount(false);
    setArchiveAccount(false);
  };

  const handleRejectBankStatement = async () => {
    setShowLoader(true);
    UniversalRefreshToast("Unmatching transactions.");

    const remitterid =
      !getAssociatedConsolidatedLoading &&
      getAssociatedConsolidatedData?.statement?.length >
        GlobalConfiguration.lengthCheckZero
        ? getAssociatedConsolidatedData?.statement?.map(
            (data) => data?.account_statement_entry_id,
          )
        : [];

    try {
      const response = await dispatch(
        removeUnmatchConsolidatedStatement({
          remitter_accounts_ids: [remitterAccountDetailsData?.id],
          mapping_ids: Array.isArray(remitterid) ? remitterid : [remitterid],
        }),
      );

      if (response?.payload?.status === true) {
        CommonToast({
          text: `${remitterid?.length === GlobalConfiguration.lengthCheckOne ? "Transaction" : "Transactions"} unmatched successfully.`,
          icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        setShowLoader(false);
        setConsolidatedLive([]);
        setselectCardLive(false);
        handleFetchPagination();
        await dispatch(
          remitterAccountDetailsById({ id: rem_account_id || id }),
        );
        if (
          remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
          GlobalConfiguration.lengthCheckZero
        ) {
          setRejectLiveStatement(true);
          setrejectBankStatement(false);
          setshowPopupReject(false);
        } else {
          if (unmatchType !== "archiveType") {
            handleDeclined(id, declineReason);
          } else {
            handleArchiveAccount(id);
            setrejectBankStatement(false);
          }
        }
      } else {
        CommonToast({
          text:
            response?.payload?.message ||
            response?.payload?.errors?.base?.[0] ||
            "Failed to unmatch transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setShowLoader(false);
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleSelect = (value) => {
    if (index === GlobalConfiguration.lengthCheckZero) {
      setSelectedValue(value);
      setCurrentPage(Number(currentPage));
      setPageSize(value);
      setConsolidatedBank([]);
      setselectCardBank(false);
      handleChange(
        consolidatedBank,
        setConsolidatedBank,
        value,
        consolidatedPaginationData?.statement,
        "account_statement_entry_id",
      );
    } else {
      setSelectedLiveValue(value);
      setLiveCurrentPage(Number(livecurrentPage));
      setLivePageSize(value);
      setselectCardLive(false);
      setConsolidatedLive([]);
      handleChange(
        consolidatedLive,
        setConsolidatedLive,
        value,
        livePaginationData?.ecollection_callbacks,
        "ecollection_callback_id",
      );
    }

    toggleDropdown();
  };

  const handlePagination = (page) => {
    if (index === GlobalConfiguration.lengthCheckZero) {
      setCurrentPage(page);
      setselectCardBank(false);
      setConsolidatedBank([]);
    } else {
      setLiveCurrentPage(page);
      setselectCardLive(false);
      setConsolidatedLive([]);
    }
  };

  const handleMatchClickLive = async () => {
    if (loadingState) return;

    try {
      setLoader(true);

      const response = await dispatch(
        getAssociatedItemisedStatements({
          page_no: livecurrentPage,
          page_size: livepageSize,
          remitter_account_id: id || rem_account_id,
          currentPage: livecurrentPage,
        }),
      ).unwrap();

      const statementIds =
        response?.ecollection_callbacks?.map(
          (item) => item?.ecollection_callback_id,
        ) || [];

      navigate("/owner_account_dashboard/consolidated_live_statement", {
        state: {
          statementid: statementIds,
          flow: "remitter_details_match_statement",
          remName: remitterAccountDetailsData?.name,
          data: id,
        },
      });
    } catch (error) {
      console.error("Failed to fetch itemised statements:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleRejectLiveStatement = async () => {
    UniversalRefreshToast("Unmatching transactions.");

    try {
      await dispatch(
        getAssociatedItemisedStatements({
          page_no: livecurrentPage,
          page_size: livepageSize,
          remitter_account_id: id || rem_account_id,
          currentPage: livecurrentPage,
        }),
      );

      const remid =
        getAssociatedItemisedData?.ecollection_callbacks?.length >
        GlobalConfiguration.lengthCheckZero
          ? getAssociatedItemisedData?.ecollection_callbacks?.map(
              (data) => data?.ecollection_callback_id,
            ) || []
          : [];

      if (remid.length === GlobalConfiguration.lengthCheckZero) {
        return;
      }

      const response = await dispatch(
        removeUnmatchItemisedStatement({
          remitter_accounts_ids: [remitterAccountDetailsData?.id],
          mapping_ids: remid,
        }),
      );

      if (response?.payload?.status === true) {
        CommonToast({
          text: `${
            remid.length === GlobalConfiguration.lengthCheckOne
              ? "Transaction"
              : "Transactions"
          } unmatched successfully.`,
          icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setConsolidatedLive([]);
        setselectCardLive(false);
        setRejectLiveStatement(false);
        await dispatch(
          remitterAccountDetailsById({ id: rem_account_id || id }),
        );
        handleLiveFetchPagination();

        if (unmatchType !== "archiveType") {
          handleDeclined(id, declineReason);
        } else {
          handleArchiveAccount(id);
        }
      } else {
        CommonToast({
          text:
            response?.payload?.message ||
            response?.payload?.errors?.base?.[0] ||
            "Failed to unmatch transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      console.error(error);

      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleRejectAccount = () => {
    setClickedBtn("reject");
    UniversalRefreshToast("accountsRefresh");
    setConsolidatedBank([]);
    setConsolidatedLive([]);
    setselectCardLive(false);
    setselectCardBank(false);

    setshowPopupReject(false);
    handleDeclined(id, declineReason);
  };

  const handleDeclined = async (id, AccountIdData) => {
    setshowPopupReject(false);
    setClickedBtn("reject");

    setConsolidatedBank([]);
    setConsolidatedLive([]);
    setselectCardLive(false);
    setselectCardBank(false);

    if (remitterAccountRejectLoading) {
      return;
    }

    try {
      const rejectId = id || rem_account_id;

      const data = await dispatch(
        remitterAccountReject({
          id: rejectId,
          rejection_reason: AccountIdData,
        }),
      );

      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "REAAccount",
          },
        });
        return;
      }

      if (data?.payload?.status === false || data?.payload === undefined) {
        let error_msg = "";
        let error_list = null;

        if (data?.payload === undefined) {
          error_msg = "An error occured while taking action on this account";
        } else if (data?.payload?.errors?.remitter_account) {
          if (
            data?.payload?.errors?.remitter_account?.length >
            GlobalConfiguration?.lengthCheckOne
          ) {
            error_list = data?.payload?.errors?.remitter_account;
            error_msg = data?.payload?.errors?.remitter_account?.[0];
          } else {
            error_msg = data?.payload?.errors?.remitter_account;
          }
        } else if (data?.payload?.status === false) {
          error_msg = data?.payload?.errors?.category?.[0];
        } else if (data?.payload?.errors?.bank_account_number?.[0]) {
          error_msg = data?.payload?.errors?.bank_account_number?.[0];
        }

        if (error_msg === "remitter account already rejected") {
          const newData = await dispatch(
            remitterAccountDetailsById({
              id: rejectId,
            }),
          );

          const updatedRemAccount = {
            ...newData?.payload?.tds?.[0],
            error_msg,
            error: data?.payload?.status === false,
          };

          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                ...(updatedRemAccount || {}),
              };
            }

            return item;
          });

          updateAllAccounts(updatedData);
        } else {
          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                error_msg,
                error: data?.payload?.status === false,
              };
            }

            return item;
          });

          updateAllAccounts(updatedData);
        }

        setDeclineReason("");
        handleClosePopup();

        if (
          Array.isArray(error_list) &&
          error_list.length > GlobalConfiguration?.lengthCheckOne
        ) {
          error_list.forEach((err) => {
            setTimeout(() => {
              CommonToast({
                text: err,
                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }, IntervalConfiguration?.intervalSmall);
          });
        } else {
          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }

        setRejectAccount(false);

        await dispatch(
          remitterAccountDetailsById({
            id: rejectId,
          }),
        );

        return;
      }

      await dispatch(
        remitterAccountDetailsById({
          id: rejectId,
        }),
      );

      const updatedData = Array.isArray(ViewAccountDetails)
        ? ViewAccountDetails.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                approval_status:
                  data?.payload?.remitter_account?.[0]?.approval_status ===
                  "pending"
                    ? "rejected"
                    : "pending",
                rejected_on:
                  data?.payload?.remitter_account?.[0]?.rejected_on || "",
                rejected_by_name:
                  data?.payload?.remitter_account?.[0]?.rejected_by_name || "",
                rejection_reason: AccountIdData,
                error: false,
                message: "",
              };
            }

            return item;
          })
        : [];

      updateAllAccounts(updatedData);

      setDeclineReason("");
      handleClosePopup();

      if (!(
        remitterAccountDetailsData?.mapped_consolidated_statement_entries_count >
          GlobalConfiguration.lengthCheckZero ||
        remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
          GlobalConfiguration.lengthCheckZero
      )) {
        toast.dismiss();

        CommonToast({
          text: "Account rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }

      setrejectBankStatement(false);
      setRejectLiveStatement(false);

      if (popup) {
        setTimeout(() => {
          closeRemAccountDetailModal();
          window.location.reload();
        }, IntervalConfiguration.intervalExtraSmall);
      }

      setRejectAccount(false);
    } catch (error) {
      console.error("handleDeclined error:", error);

      CommonToast({
        text:
          error?.message || "Something went wrong while rejecting the account.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } finally {
      setRejectAccountLoader(false);
      setShowLoader(false);
      setUnmatchType("");
    }
  };

  const handleApprovalDetails = async (id) => {
    setRejectAccountLoader(true);
    setApproveAccount(true);
    setClickedBtn("approve");
    setConsolidatedBank([]);
    setConsolidatedLive([]);

    let response;

    try {
      UniversalRefreshToast("approvalaccountsRefresh");

      // Approve API call
      response = await dispatch(
        remitterAccountApprove({
          id: popup ? rem_account_id : id,
        }),
      );

      // Unauthorized check
      if (
        response?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "REAAccount",
          },
        });
        return;
      }

      // ================= ERROR CASE =================
      if (
        response?.payload?.status === false ||
        response?.payload === undefined
      ) {
        let error_msg = "";

        if (response?.payload === undefined) {
          error_msg = "An error occured while taking action on this account";
        } else if (response?.payload?.errors?.remitter_account?.[0]) {
          error_msg = response?.payload?.errors?.remitter_account?.[0];
        } else if (response?.payload?.errors?.bank_account_number?.[0]) {
          error_msg = response?.payload?.errors?.bank_account_number?.[0];

          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        } else {
          error_msg = "An unknown error occurred.";

          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }

        // Already approved case
        if (error_msg === "remitter account already approved") {
          const updatedData = remitterAccountDetailsData?.map((item) => {
            if (item.id === (popup ? rem_account_id : id)) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "approved" : "pending",
              };
            }

            return item;
          });

          setViewAccountDetails(updatedData);
          setRejectAccountLoader(false);

          await dispatch(
            remitterAccountDetailsById({
              id: rem_account_id || id,
            }),
          );
        } else {
          const updatedData = [remitterAccountDetailsData]?.map((item) => {
            if (item.id === (popup ? rem_account_id : id)) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "pending" : "",
                error_msg,
              };
            }

            return item;
          });

          setViewAccountDetails(updatedData);
        }

        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setRejectAccountLoader(false);
        setApproveAccount(false);
        // await dispatch(
        //   remitterAccountDetailsById({
        //     id: rem_account_id || id,
        //   }),
        // );
      }

      // ================= SUCCESS CASE =================
      else {
        const updatedData = [remitterAccountDetailsData]?.map((item) => {
          if (item.id === (popup ? rem_account_id : id)) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "approved" : "pending",
            };
          }

          return item;
        });

        setViewAccountDetails(updatedData);

        await dispatch(
          remitterAccountDetailsById({
            id: rem_account_id || id,
          }),
        );
        toast.dismiss();
        CommonToast({
          text: "Account approved successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setApproveAccount(false);

        if (popup) {
          setTimeout(() => {
            closeRemAccountDetailModal();
            window.location.reload();
          }, IntervalConfiguration.intervalExtraSmall);
        }
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } finally {
      setShowLoader(false);
      setRejectAccountLoader(false);
      setApproveAccount(false);
    }
  };

  const handleUnArchive = () => {
    setUnArchiveAccount(true);
    if (remitterAccountDetailsData?.archived === "N") {
      setUnArchiveAccount(false);
    } else {
      setUnArchiveAccount(true);
    }
  };

  const handleLiveUnmatchStatement = async (matchid) => {
    setUnmatchStatementPopup(false);
    setUnmatchLoader(true);
    UniversalRefreshToast(
      matchid?.length === GlobalConfiguration.lengthCheckOne
        ? "Unmatching transaction"
        : "Unmatching transactions",
    );
    try {
      const mappingIds = Array.isArray(matchid)
        ? matchid.map((item) => item.ecollection_callback_id)
        : [matchid.ecollection_callback_id];

      const data = await dispatch(
        removeUnmatchItemisedStatement({
          remitter_accounts_ids: [remitterAccountDetailsData?.id],
          mapping_ids: !selectCardLive ? matchid : mappingIds,
        }),
      );

      if (data?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text:
            matchid?.length === GlobalConfiguration.lengthCheckOne
              ? "Transaction unmatched successfully."
              : "Transactions unmatched successfully.",
          icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        setConsolidatedLive([]);
        setselectCardLive(false);
        handleFetch();
        handleLiveFetchPagination();
      } else {
        toast.dismiss();
        CommonToast({
          text: data?.payload?.message || data?.payload?.errors?.base?.[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }

    setUnmatchLoader(false);
  };

  const handleUnmatchStatement = async (matchid) => {
    setUnmatchLoader(true);
    setUnmatchStatementPopup(false);
    UniversalRefreshToast(
      matchid?.length === GlobalConfiguration.lengthCheckOne
        ? "Unmatching transaction"
        : "Unmatching transactions",
    );
    try {
      const mappingIds = Array.isArray(matchid)
        ? matchid.map((item) => item.account_statement_entry_id)
        : [matchid.account_statement_entry_id];

      const data = await dispatch(
        removeUnmatchConsolidatedStatement({
          remitter_accounts_ids: [remitterAccountDetailsData?.id],
          mapping_ids: !selectCardBank ? matchid : mappingIds,
        }),
      );

      if (data?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text:
            matchid?.length === GlobalConfiguration.lengthCheckOne
              ? "Transaction unmatched successfully."
              : "Transactions unmatched successfully.",
          icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        setConsolidatedBank([]);
        setselectCardBank(false);
        handleFetch();
        handleFetchPagination();
      } else {
        toast.dismiss();
        CommonToast({
          text: data?.payload?.message || data?.payload?.errors?.base?.[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }

    setUnmatchLoader(false);
  };

  const handleArchive = () => {
    if (remitterAccountDetailsData?.archived === "N") {
      setArchiveAccount(true);
    } else {
      setArchiveAccount(false);
    }
  };

  const handleArchiveButton = async () => {
    setUnmatchType("archiveType");
    setArchiveAccount(false);

    setshowPopupReject(false);
    handleArchiveAccount(id);
    // }
  };

  const handleArchiveAccount = async (id) => {
    try {
      setArchiveAccount(false);
      setShowLoader(true);
      UniversalRefreshToast("archive");
      toast.dismiss();
      const archivedResponse = await dispatch(remitterAccountArchive(id));

      const isArchiveSuccess =
        archivedResponse.type !== "achivedRemitterAccountDetail/rejected" ||
        archivedResponse.payload === "Remitter account already archived.";

      if (isArchiveSuccess) {
        const data = await dispatch(remitterAccountDetailsById({ id }));

        if (data?.payload?.status) {
          CommonToast({
            text: "Account archived successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            buttonNeeded: false,
          });
        }
      }
    } finally {
      handleCloseModal();
      setShowLoader(false);
    }
  };

  const unamtchAllTxn = async () => {
    setUnmatchType("UnmatchAllTxn");

    const remitterAccountId = id || rem_account_id;

    const bankCount =
      remitterAccountDetailsData?.mapped_consolidated_statement_entries_count ??
      0;

    const liveCount =
      remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count ??
      0;

    const pageSize = PaginationConfiguration.paginationSmall;

    try {
      setRejectAccount(false);

      UniversalRefreshToast("Unmatching transactions and rejecting account.");

      let remitterIds = [];

      if (bankCount > GlobalConfiguration.lengthCheckZero) {
        const totalBankPages = Math.ceil(bankCount / pageSize);

        for (
          let page = GlobalConfiguration.lengthCheckOne;
          page <= totalBankPages;
          page++
        ) {
          const consolidatedResponse = await dispatch(
            getAssociatedConsolidatedStatements({
              page_no: page,
              page_size: pageSize,
              remitter_account_id: remitterAccountId,
            }),
          ).unwrap();

          if (!consolidatedResponse) {
            setRejectAccountLoader(false);
          }

          const consolidatedStatements = consolidatedResponse?.statement || [];

          const pageIds = consolidatedStatements
            .map((data) => data?.account_statement_entry_id)
            .filter(Boolean);

          remitterIds = [...remitterIds, ...pageIds];
        }
      }

      if (remitterIds.length > GlobalConfiguration.lengthCheckZero) {
        await dispatch(
          removeUnmatchConsolidatedStatement({
            remitter_accounts_ids: [remitterAccountId],
            mapping_ids: remitterIds,
          }),
        ).unwrap();

        setBankStatementCount(0);
      }

      handleFetchPagination();

      let itemisedIds = [];

      if (liveCount > GlobalConfiguration.lengthCheckZero) {
        const totalLivePages = Math.ceil(liveCount / pageSize);

        for (
          let page = GlobalConfiguration.lengthCheckOne;
          page <= totalLivePages;
          page++
        ) {
          const itemisedResponse = await dispatch(
            getAssociatedItemisedStatements({
              page_no: page,
              page_size: pageSize,
              remitter_account_id: remitterAccountId,
            }),
          ).unwrap();

          const itemisedStatements =
            itemisedResponse?.ecollection_callbacks || [];

          const pageIds = itemisedStatements
            .map((data) => data?.ecollection_callback_id)
            .filter(Boolean);

          itemisedIds = [...itemisedIds, ...pageIds];
        }
      }

      if (itemisedIds.length > GlobalConfiguration.lengthCheckZero) {
        await dispatch(
          removeUnmatchItemisedStatement({
            remitter_accounts_ids: [remitterAccountId],
            mapping_ids: itemisedIds,
          }),
        ).unwrap();

        setLiveStatementCount(0);
      }

      handleLiveFetchPagination();

      toast.dismiss();

      CommonToast({
        text: "Transactions unmatched and account rejected successfully.",
        variant: "var(--success)",
        icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        buttonNeeded: false,
      });

      handleDeclined(id, declineReason);
    } catch (error) {
      toast.dismiss();

      CommonToast({
        text:
          error?.message ||
          error?.errors?.remitter_account?.[0] ||
          error?.errors?.user_unauthorized?.[0] ||
          "Something went wrong while unmatching transactions.",
        variant: "var(--error)",
        icon: ICONS.ERROR,
        buttonNeeded: false,
      });
    } finally {
      setRejectAccount(false);

      setshowPopupReject(false);
    }
  };

  const handleUnArchiveButton = async () => {
    try {
      setUnArchiveAccount(false);
      setShowLoader(true);

      UniversalRefreshToast("unarchive");
      toast.dismiss();

      const unarchivedResponse = await dispatch(remitterAccountUnarchive(id));

      if (
        unarchivedResponse?.type === "unachivedRemitterAccountDetail/rejected"
      ) {
        const errorMessage =
          unarchivedResponse?.payload?.errors?.remitter_account?.[0] ||
          unarchivedResponse?.payload ||
          "Something went wrong while unarchiving the account.";

        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });

        return;
      }

      const data = await dispatch(remitterAccountDetailsById({ id }));

      if (data?.payload?.status === true) {
        const updatedData = {
          ...data.payload,
          error_msg: "",
        };

        setViewAccountDetails(updatedData);

        CommonToast({
          text: "Account unarchived successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } finally {
      setShowLoader(false);
      handleCloseModal();
    }
  };

  useEffect(() => {
    handleFetch();
    let availableLabels = sessionStorage?.getItem(
      "remitterAccountAvailableLabels",
    );
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [rem_account_id, id]);

  useEffect(() => {
    if (
      location?.state?.flow === "live_match_transaction" ||
      flow === "unmatch_transaction"
    ) {
      setIsLiveApiCalled(false);
      setIsBankApiCalled(false);
    }
  }, [id, location?.state?.flow, flow]);

  const handleClose = () => {
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
    }
    setShowLabelsPopup(false);
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoader(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const res = await dispatch(
      remitterAddNewLabel({
        record_ids: toArray(id),
        labels: labelsToAssign,
      }),
    );

    if (remitterAddNewLabel.fulfilled.match(res)) {
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await handleFetch();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (remitterAddNewLabel.rejected.match(res)) {
      await handleFetch();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    setLoader(false);
    if (remitterAddNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoader(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      remitterRemoveNewLabel({
        record_ids: toArray(id),
        labels: labelsToUnassign,
      }),
    );

    if (remitterRemoveNewLabel.fulfilled.match(res)) {
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await handleFetch();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (remitterRemoveNewLabel.rejected.match(res)) {
      await handleFetch();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    setLoader(false);
    if (remitterRemoveNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleCardClick = (transactions) => {
    handleSingleSelect(
      consolidatedBank,
      setConsolidatedBank,
      selectedValue,
      transactions,
      "account_statement_entry_id",
    );
  };

  const handleLiveCardClick = (transactions) => {
    handleSingleSelect(
      consolidatedLive,
      setConsolidatedLive,
      selectedLiveValue,
      transactions,
      "ecollection_callback_id",
    );
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration?.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    const observers = [];

    if (bankBarRef.current) {
      const ro = new ResizeObserver(([entry]) => {
        setBankBarHeight(entry.contentRect.height + 20);
      });
      ro.observe(bankBarRef.current);
      observers.push(ro);
    }

    if (liveBarRef.current) {
      const ro = new ResizeObserver(([entry]) => {
        setLiveBarHeight(entry.contentRect.height + 20);
      });
      ro.observe(liveBarRef.current);
      observers.push(ro);
    }

    return () => observers.forEach((ro) => ro.disconnect());
  }, [index]);

  const handleToggleBankSelect = () => {
    const next = !selectCardBank;
    setselectCardBank(next);
    setConsolidatedBank([]);

    if (next) {
      requestAnimationFrame(() => {
        if (bankBarRef.current && scrollBankRef.current) {
          const height = bankBarRef.current.getBoundingClientRect().height;
          scrollBankRef.current.style.marginTop = `${height + 20}px`;
        }
      });
    } else {
      if (scrollBankRef.current) {
        scrollBankRef.current.style.marginTop = "0px";
      }
    }
  };

  const handleToggleLiveSelect = () => {
    const next = !selectCardLive;
    setselectCardLive(next);
    setConsolidatedLive([]);

    if (next) {
      requestAnimationFrame(() => {
        if (liveBarRef.current && scrollLiveRef.current) {
          const height = liveBarRef.current.getBoundingClientRect().height;
          scrollLiveRef.current.style.marginTop = `${height + 20}px`;
        }
      });
    } else {
      if (scrollLiveRef.current) {
        scrollLiveRef.current.style.marginTop = "0px";
      }
    }
  };

  useEffect(() => {
    if (selectCardBank && bankBarRef.current && scrollBankRef.current) {
      const height = bankBarRef.current.getBoundingClientRect().height;
      scrollBankRef.current.style.marginTop = `${height + 20}px`;
    }
  }, [remitterAccountDetailsData, consolidatedPaginationData, showLoader]);

  useEffect(() => {
    if (selectCardLive && liveBarRef.current && scrollLiveRef.current) {
      const height = liveBarRef.current.getBoundingClientRect().height;
      scrollLiveRef.current.style.marginTop = `${height + 20}px`;
    }
  }, [remitterAccountDetailsData, livePaginationData, showLoader]);

  return (
    <>
      <>{RestrictedActionPopup}</>

      {similarAccountPopup && (
        <>
          <div style={{ zIndex: "var(--z-index-modal)" }}>
            <RemitAccountViewAllPopup
              type={"RemitterAcc"}
              headerTitle={`Similar accounts`}
              propType={"similerAccount"}
              id={remitterAccountDetailsData?.id}
              remName={remitterAccountDetailsData?.name}
              headersubtext={`The following accounts have similar names.`}
              closePopup={() => setSimilarAccountPopup(false)}
              handleConfirmBtnClick={() => {
                return;
              }}
              onCardNavigate
            />
          </div>
        </>
      )}

      {editPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <EditCommonPopup
            btnOneHandleFunction={() => {
              setEditpopup(false);
            }}
            headerTitle="Select the option to edit:"
            alertBackground="emphasis"
            chipsArray={chipsArray}
            btnOneText="Cancel"
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Edit"
            btnTwoHandleFunction={handleApply}
            // btnTwoIsDisabled={
            //   selectedChipIndex === GlobalConfiguration.lengthCheckZero
            // }
            btnTwoInActiveVariantNeeded
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            // btnTwoIsLoaderNeeded={handleLoading}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            defaultHeight={selectedChipIndex}
          />
        </div>
      )}

      {viewLiveStatementOpenPop && (
        <LargePopupRedirect
          headerTitle="Consolidated live statement "
          headersubtext="View-only mode. Actions are restricted."
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          headertextSize="font-md"
          fullviewisDisabled={false}
          fullviewenabledTextColor="var(--text-primary)"
          fullviewenabledBgColor="var(--primary-nav)"
          fullviewhoverOption="white"
          fullviewicon={ICONS?.REDIRECT}
          fullviewdisabledBgColor="var(--text-disabled)"
          closeiconbtnType="button"
          closeiconhandleFunction={() => {
            setViewLivestatementOpenPop(false);
          }}
          closeiconisDisabled={false}
          closeiconenabledBgColor="var(--primary-nav)"
          closeicondisabledBgColor="var(--text-disabled)"
          closeiconhoverOption="white"
          closeicon={ICONS?.CLOSE}
          isbottomSectionneed={false}
          bottomHeaderTextNeed={false}
          isscrollRequired={true}
        >
          <OwnerAccountItemisedReportComp
            popType={"remitterBankStatement"}
            flow={"rejectStatementdetails"}
            statement_entry_id={statementLiveConsolidatedId}
            setViewstatementOpenPop={setViewLivestatementOpenPop}
          />
        </LargePopupRedirect>
      )}
      {viewStatementOpenPop && (
        <LargePopupRedirect
          headerTitle="Consolidated bank statement "
          headersubtext="View-only mode. Actions are restricted."
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          headertextSize="font-md"
          fullviewisDisabled={false}
          fullviewenabledTextColor="var(--text-primary)"
          fullviewenabledBgColor="var(--primary-nav)"
          fullviewhoverOption="white"
          fullviewicon={ICONS?.REDIRECT}
          fullviewdisabledBgColor="var(--text-disabled)"
          closeiconbtnType="button"
          closeiconhandleFunction={() => {
            setViewstatementOpenPop(false);
          }}
          closeiconisDisabled={false}
          closeiconenabledBgColor="var(--primary-nav)"
          closeicondisabledBgColor="var(--text-disabled)"
          closeiconhoverOption="white"
          closeicon={ICONS?.CLOSE}
          isbottomSectionneed={false}
          bottomHeaderTextNeed={false}
          isscrollRequired={true}
        >
          <OwnerAccountConsolidatedBankStatement
            popType={"remitterBankStatement"}
            flow={"rejectStatementdetails"}
            statement_entry_id={statementId}
            setViewstatementOpenPop={setViewstatementOpenPop}
          />
        </LargePopupRedirect>
      )}

      {unmatchStatementPopup && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <SmallPopup
            headerTitle={`Confirm unmatching ${consolidatedBank?.length === GlobalConfiguration.lengthCheckOne || consolidatedLive?.length === GlobalConfiguration.lengthCheckOne ? " this transaction?" : "these transactions?"}`}
            subtext={` ${consolidatedBank?.length === GlobalConfiguration.lengthCheckOne || consolidatedLive?.length === GlobalConfiguration.lengthCheckOne ? "This transaction" : "These transactions"}  will no longer be linked to the remitter account.`}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setUnmatchStatementPopup(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Unmatch"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() => {
              if (
                consolidatedBank?.length > GlobalConfiguration.lengthCheckZero
              ) {
                handleUnmatchStatement(consolidatedBank);
              } else {
                handleLiveUnmatchStatement(consolidatedLive);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {rejectBankStatement && (
        <div className="fixed top-top-base left-left-base w-full h-full   flex items-center justify-center z-z-index-modal">
          <LargePopupRedirect
            headerTitle="Unmatch from consolidated bank statement"
            headersubtext={`${unmatchType === "archiveType" ? "The following transactions are matched and need to be unmatched before archiving this account." : "The following transactions are matched and need to be unmatched before rejecting this account."}`}
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setrejectBankStatement(false);
              setDeclineReason("");
              setShowLoader(false);
              setUnmatchType("");
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              hasUnmatchPermission && unmatchType !== "archiveType"
                ? "To reject the account, please unmatch the transactions listed above by clicking the “Unmatch all” button."
                : unmatchType === "archiveType"
                  ? "To archive the account, unmatch the transactions listed above by clicking the “Unmatch all” button."
                  : "To unmatch the transactions, please contact the authorised person who has the feature to unmatch the transactions."
            }
            isbottomSectionneed={true}
            isDisabled={!hasUnmatchPermission}
            btnText={"Unmatch all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              if (hasUnmatchPermission) {
                handleRejectBankStatement();
              } else {
                navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "RMapping",
                  },
                });
              }
            }}
            isLoaderNeeded={true}
            isLoading={showLoader ? true : false}
            enabledBgColor={
              hasUnmatchPermission
                ? "var(--negative-act)"
                : "var(--text-disabled)"
            }
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <OwnerAccountConsolidatedBankStatement
              popType={"remitterBankStatement"}
              flow={"rejectStatementdetails"}
              remitter_account_id={id || rem_account_id}
              setViewstatementOpenPop={() => setrejectBankStatement(false)}
            />
          </LargePopupRedirect>
        </div>
      )}
      {rejectLiveStatement && (
        <div className="fixed top-top-base left-left-base w-full h-full   flex items-center justify-center z-z-index-modal">
          <LargePopupRedirect
            headerTitle="Unmatch from consolidated live statement"
            headersubtext={`${unmatchType === "archiveType" ? "The following transactions are matched and need to be unmatched before archiving this account." : "The following transactions are matched and need to be unmatched before rejecting this account."}`}
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setRejectLiveStatement(false);
              setDeclineReason("");
              setShowLoader(false);
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              hasUnmatchPermission && unmatchType !== "archiveType"
                ? "To reject the account, please unmatch the transactions listed above by clicking the “Unmatch all” button."
                : unmatchType === "archiveType"
                  ? "To archive the account, unmatch the transactions listed above by clicking the “Unmatch all” button."
                  : "To unmatch the transactions, please contact the authorised person who has the feature to unmatch the transactions."
            }
            isbottomSectionneed={true}
            btnText={"Unmatch all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              if (hasUnmatchPermission) {
                handleRejectLiveStatement();
              } else {
                navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "RMapping",
                  },
                });
              }
            }}
            isLoaderNeeded={true}
            isLoading={showLoader ? true : false}
            enabledBgColor={
              hasUnmatchPermission
                ? "var(--negative-act)"
                : "var(--text-disabled)"
            }
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={!hasUnmatchPermission}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <OwnerAccountItemisedReportComp
              popType={true}
              flow={"rejectStatementdetails"}
              remitter_account_id={id || rem_account_id}
              setViewstatementOpenPop={() => setRejectLiveStatement(false)}
            />
          </LargePopupRedirect>
        </div>
      )}

      {openLabelSearchPopup && (
        <>
          <div style={{ zIndex: "var(--z-index-modal)" }}>
            <RemitAccountViewAllPopup
              type={"RemitterAcc"}
              headerTitle={`Accounts labelled by - ${labelName}`}
              remLabel={labelName}
              propType={"remitterDetails"}
              headersubtext={`All accounts related to ${labelName} are listed below.`}
              closePopup={() => setOpenLabelSearchPopup(false)}
              handleConfirmBtnClick={() => {
                return;
              }}
              onCardNavigate
            />
          </div>
        </>
      )}

      {showLabelsPopup && (
        <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="These will be used to generate statistics for the associated account."
            closehandleFunction={() => setShowLabelsPopup(false)}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={id}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={allLabelsData?.remitter_accounts}
            labelActionDispatchedRef={labelActionDispatchedRef}
            onClose={handleClose}
            loading={loader}
            setLoading={setLoader}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="details"
          />
        </div>
      )}

      {isService && (
        <>
          {" "}
          <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"></div>
          <SmallPopupWithBulletPoint
            headerTitle="Matched transactions found"
            secondHeaderFontWeight={true}
            secondHeaderTitle="Feature not assigned for unmatching transactions."
            subtext="Contact an authorised person who has the feature to unmatch the following transactions before rejecting this account.
"
            subtextwithbullet="Y"
            bulletPoints={[
              ...(remitterAccountDetailsData?.mapped_consolidated_statement_entries_count >
              0
                ? [
                    `Consolidated bank statement: ${remitterAccountDetailsData.mapped_consolidated_statement_entries_count} transactions`,
                  ]
                : []),

              ...(remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
              0
                ? [
                    `Consolidated live statement: ${remitterAccountDetailsData.mapped_itemised_consolidated_statement_entries_count} transactions`,
                  ]
                : []),
            ]}
            btnOneHandleFunction={() => {
              setIsService(false);
            }}
            btnOneText="Cancel"
            btnTwoHandleFunction={() => {
              return;
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Unmatch & reject"
            btnTwoEnabledBgColor="var(--text-disabled)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoIsDisabled={true}
            btnTwoInActiveVariantNeeded={true}
            btnTwoHoverOption="black"
          />
        </>
      )}
      {showPopupReject && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <SmallPopupWithInput
            headerTitle="Reject account"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtextwithbullet="Y"
            secondHeaderTitle="Provide the reason for rejection."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText="Minimum 10 characters required."
            noteColor="text-secondary"
            inputPlaceholder={"Reason"}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            bulletPoints={[
              "Once rejected, this account can no longer be used for matching the transactions.",

              ...(remitterAccountDetailsData?.mapped_consolidated_statement_entries_count >
                0 ||
              remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
                0
                ? [
                    {
                      text: "Rejecting this account will also unmatch the following transactions:",
                      subPoints: [
                        ...(remitterAccountDetailsData?.mapped_consolidated_statement_entries_count >
                        0
                          ? [
                              `Bank transactions: ${remitterAccountDetailsData.mapped_consolidated_statement_entries_count}`,
                            ]
                          : []),

                        ...(remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
                        0
                          ? [
                              `Live transactions: ${remitterAccountDetailsData.mapped_itemised_consolidated_statement_entries_count}`,
                            ]
                          : []),
                      ],
                    },
                  ]
                : []),
            ]}
            inputMaxLength={GlobalConfiguration.rejectReasonMaxLength}
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              handleClosePopup();
              setRejectAccountLoader(false);
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText={
              remitterAccountDetailsData?.mapped_consolidated_statement_entries_count >
                GlobalConfiguration.lengthCheckZero ||
              remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
                GlobalConfiguration.lengthCheckZero
                ? "Unmatch & reject"
                : "Reject"
            }
            btnTwoHandleFunction={() => {
              if (
                remitterAccountDetailsData?.mapped_consolidated_statement_entries_count >
                  GlobalConfiguration.lengthCheckZero ||
                remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
                  GlobalConfiguration.lengthCheckZero
              ) {
                if (hasUnmatchPermission) {
                  unamtchAllTxn();
                } else {
                  navigate("/feature_not_assigned", {
                    state: {
                      unavailableService: "RMapping",
                    },
                  });
                }
              } else {
                handleRejectAccount();
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              declineReason.trim().length <
              GlobalConfiguration.rejectReasonMinLength
                ? true
                : false
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      {archiveAccount && (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop !bg-opacity-dark-opacity">
            <SmallPopupWithBulletPoint
              headerTitle={"Confirm archiving this account?"}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              bulletPoints={[
                "This account will become inactive.",
                "It cannot be used unless unarchived.",
                "Matching actions will be restricted for archived accounts.",
              ]}
              isTextInputField={false}
              btnOneText="Cancel"
              btnOneHandleFunction={() => setArchiveAccount(false)}
              btnOneOutLineColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneHoverOption="white"
              btnTwoText={"Archive"}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
              btnTwoHandleFunction={() => {
                setselectCardLive(false);
                setselectCardBank(false);
                setConsolidatedBank([]);
                setConsolidatedLive([]);
                handleArchiveButton();
              }}
            />
          </div>
        </>
      )}

      {unArchiveAccount && (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop !bg-opacity-dark-opacity">
            <SmallPopupWithBulletPoint
              headerTitle={"Confirm unarchiving this account?"}
              bulletPoints={[
                "This account will become active.",
                "The status will be changed to pending and will require approval",
              ]}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              isTextInputField={false}
              btnOneText="Cancel"
              btnOneHandleFunction={() => setUnArchiveAccount(false)}
              btnOneOutLineColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneHoverOption="white"
              btnTwoText={"Unarchive"}
              btnTwoEnabledBgColor="var(--positive-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
              btnTwoHandleFunction={() => {
                setConsolidatedBank([]);
                setConsolidatedLive([]);
                setselectCardLive(false);
                setselectCardBank(false);
                handleUnArchiveButton();
              }}
            />
          </div>
        </>
      )}
      <div
        className={`  ${popup ? "h-full" : "h-screen"} relative w-full flex flex-col bg-primary-bg overflow-hidden`}
      >
        {loader ||
        (unmatchType !== "UnmatchAllTxn" &&
          (getAssociatedItemisedLoading ||
            getAssociatedConsolidatedLoading)) ? (
          <div
            className={`absolute top-top-base z-z-index-fixed-ui h-height-full w-width-full flex justify-center items-center`}
          >
            <Loader />
          </div>
        ) : (
          <>
            <div
              className={`min-h-mobile-navbar-height ${popup ? "hidden" : "block"} Qsmd:min-h-navbar-breadcrumb-height bg-primary-nav w-full`}
            >
              <div className="fixed top-top-base  left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
                <TopNavComponent
                  topNavHeader={"Remitter"}
                  isFormattingNotRequired
                  topNavSubText="Account details"
                  handleBack={(e) => {
                    navigate(GlobalConfiguration.navigate_back);
                  }}
                />
              </div>
            </div>
            <div
              className={`overflow-y-auto flex-1 ${(liveLoader || bankLoader) && "flex flex-col"} `}
            >
              <div className="bg-primary-nav w-full">
                <div className="w-full mx-auto my-margin-base max-w-tab-width-normal h-fit flex flex-col overflow-hidden Qlg:px-padding-base">
                  <div>
                    <div className="flex justify-between w-full">
                      <div className="pt-padding-lg ml-margin-sm pb-padding-md px-padding-md Qsmd:px-padding-base Qsmd:py-padding-md flex items-center">
                        <TitleSubtitlePair
                          title={
                            remitterAccountDetailsData
                              ? remitterAccountDetailsData?.name
                              : "NA"
                          }
                          titleColor="text-primary"
                          subtitle={"Account name"}
                          alignRight={false}
                          hoverOption="white"
                          isBold={false}
                          variant="md"
                        />
                      </div>

                      <div className="hidden h-positive-negative-btn-height Qsmd:flex bg-primary-nav-act">
                        <div>
                          <TopNavSmallButton
                            btnText={
                              <>
                                Match in bank <br /> statement
                              </>
                            }
                            handleFunction={() => {
                              if (popup) {
                                actionRestricted();
                                return;
                              }

                              if (hasMatchPermission) {
                                if (
                                  remitterAccountDetailsData?.approval_status ===
                                    "archived" ||
                                  remitterAccountDetailsData?.approval_status ===
                                    "rejected"
                                ) {
                                  CommonToast({
                                    text: isArchivedAccount
                                      ? "Action restricted for archived account. Unarchive it to enable this action."
                                      : "Action restricted for rejected account. Edit it to enable this action.",
                                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                    variant: "var(--error)",
                                  });
                                  return;
                                }

                                if (!loadingState) {
                                  navigate(
                                    "/owner_account_dashboard/consolidated_bank_statement",
                                    {
                                      state: {
                                        statementid: ConsolidatedBankTotalId,
                                        data: id,
                                        remName:
                                          remitterAccountDetailsData?.name,
                                        flow: "remitter_details_match_statement",
                                      },
                                    },
                                  );
                                }
                              } else {
                                const requiredServices = [
                                  "AMapping",
                                  "VAccountBalance",
                                ];

                                const unavailableServices =
                                  requiredServices.filter(
                                    (service) => !services?.includes(service),
                                  );

                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: unavailableServices,
                                  },
                                });
                              }
                            }}
                            isDisabled={
                              loadingState ||
                              !hasMatchPermission ||
                              popup ||
                              isArchivedAccount ||
                              isRejectAccount
                            }
                            imgColor="var(--text-primary)"
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            disabledBgColor="var(--primary-nav-act)"
                            icon={ICONS?.MATCHED_WITH_CIRCLE}
                            hoverOption="white"
                            fullWidthRequired={false}
                          />
                        </div>
                        <div className="border-r border-primary-bg my-margin-md"></div>
                        <div>
                          <TopNavSmallButton
                            btnText={
                              <>
                                Match in live <br /> statement
                              </>
                            }
                            handleFunction={() => {
                              if (popup) {
                                actionRestricted();
                                return;
                              }

                              if (hasLiveMatchPermission) {
                                if (
                                  remitterAccountDetailsData?.approval_status ===
                                    "archived" ||
                                  remitterAccountDetailsData?.approval_status ===
                                    "rejected"
                                ) {
                                  CommonToast({
                                    text: isArchivedAccount
                                      ? "Action restricted for archived account. Unarchive it to enable this action."
                                      : "Action restricted for rejected account. Edit it to enable this action.",
                                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                    variant: "var(--error)",
                                  });
                                  return;
                                }

                                handleMatchClickLive();
                              } else {
                                const requiredServices = [
                                  "AMapping",
                                  "VItemisedStatement",
                                ];

                                const unavailableServices =
                                  requiredServices.filter(
                                    (service) => !services?.includes(service),
                                  );

                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: unavailableServices,
                                  },
                                });
                              }
                            }}
                            isDisabled={
                              loadingState ||
                              !hasMatchPermission ||
                              popup ||
                              isArchivedAccount ||
                              isRejectAccount
                            }
                            imgColor="var(--text-primary)"
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            disabledBgColor="var(--primary-nav-act)"
                            icon={ICONS?.MATCHED_WITH_CIRCLE}
                            hoverOption="white"
                            fullWidthRequired={false}
                          />
                        </div>
                        <div className="border-r border-primary-bg my-margin-md"></div>
                        <div>
                          <TopNavSmallButton
                            btnText={
                              <>
                                Edit <br /> account
                              </>
                            }
                            handleFunction={() => {
                              if (popup) {
                                actionRestricted();
                              } else {
                                if (
                                  remitterAccountDetailsData?.approval_status !==
                                  "archived"
                                ) {
                                  if (hasEditPermission) {
                                    if (!loadingState) {
                                      setEditpopup(true);
                                      // navigate(
                                      //   `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/edit_account_details/${id}`,
                                      // );
                                    }
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "REUAccount",
                                      },
                                    });
                                  }
                                }
                              }
                            }}
                            isDisabled={
                              loadingState || popup || !hasEditPermission
                            }
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            disabledBgColor="var(--primary-nav-act)"
                            icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                            hoverOption="white"
                          />
                        </div>
                        <div className="border-r border-primary-bg my-margin-md"></div>
                        <div>
                          <TopNavSmallButton
                            btnText={
                              remitterAccountDetailsData?.approval_status ===
                              "archived" ? (
                                <>
                                  Unarchive <br /> account
                                </>
                              ) : (
                                <>
                                  Archive <br /> account
                                </>
                              )
                            }
                            icon={
                              remitterAccountDetailsData?.approval_status ===
                              "archived"
                                ? ICONS?.UNARCHIVE
                                : ICONS?.ARCHIVE
                            }
                            isDisabled={
                              loadingState ||
                              popup ||
                              !services?.find(
                                (service) =>
                                  service === "REAAccountArchive" ||
                                  service === "Admin",
                              )
                            }
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary"}
                            hoverOption="white"
                            handleFunction={() => {
                              const hasPermission = services?.some(
                                (service) =>
                                  service === "REAAccountArchive" ||
                                  service === "Admin",
                              );

                              if (popup) {
                                actionRestricted();
                                return;
                              }

                              if (hasPermission) {
                                if (!loadingState) {
                                  handleUnArchive();
                                  handleArchive();
                                }
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "REAAccountArchive",
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-t border-primary-bg"></div>
                  <div className=" h-fit Qsmd:h-edit-popup-row-default px-padding-base relative">
                    <div className="flex flex-col Qsmd:flex-row Qsmd:flex">
                      <div className="flex flex-1 px-padding-md ml-margin-sm Qsmd:px-padding-base py-padding-md pb-padding-md Qmd:pb-padding-md">
                        <TitleSubtitlePair
                          title={
                            services?.includes("REAAccount") &&
                            remitterAccountDetailsData?.approval_status ===
                              "pending"
                              ? "Require approval"
                              : remitterAccountDetailsData
                                ? remitterAccountDetailsData?.approval_status
                                    ?.toLowerCase()
                                    ?.replace(/\b\w/g, (char) =>
                                      char.toUpperCase(),
                                    )
                                : "NA"
                          }
                          titleColor={
                            remitterAccountDetailsData?.approval_status ===
                            "approved"
                              ? "awaiting"
                              : remitterAccountDetailsData?.approval_status ===
                                  "pending"
                                ? "pending"
                                : remitterAccountDetailsData?.approval_status ===
                                    "archived"
                                  ? "abandoned"
                                  : remitterAccountDetailsData?.approval_status ===
                                      "rejected"
                                    ? "failed"
                                    : "abandoned"
                          }
                          subtitle={"Account status"}
                          alignRight={false}
                          hoverOption="white"
                          isBold={true}
                          variant="md"
                        />
                      </div>

                      <div
                        className={`${remitterAccountDetailsData?.approval_status === "pending" ? "block" : "hidden"} h-positive-negative-btn-height `}
                      >
                        {rejectAccountLoader || approveAccount ? (
                          <>
                            <div className="Qsmd:w-max-button-width-for-approval-animation w-full flex">
                              <div
                                className={`w-width-full flex justify-center items-center py-padding-lg ${
                                  clickedBtn === "reject"
                                    ? "bg-negative-act"
                                    : "bg-positive-act"
                                }`}
                              >
                                <Loader
                                  height="var(--icon-lg)"
                                  width="var(--icon-lg)"
                                />
                              </div>
                            </div>
                          </>
                        ) : ViewAccountDetails?.[0]?.error_msg ? (
                          <div
                            // key={account.id}
                            className={`h-full flex justify-end ${
                              ViewAccountDetails?.[0]?.error_msg
                                ? "bg-Button-green "
                                : ViewAccountDetails?.[0]?.error_msg
                                  ? "bg-Button-green"
                                  : ""
                            }`}
                          >
                            <div className="flex flex-row gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm">
                              <div className="flex place-items-center">
                                <img
                                  src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                                  alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                                  className="w-icon-lg h-icon-lg mr-margin-button-m"
                                />
                              </div>
                              <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                <span className="font-sans text-font-sm text-text-primary font-semibold text-ellipsis overflow-hidden w-full block">
                                  Failed to take action
                                </span>
                                <span className="font-sans text-xs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                  {ViewAccountDetails?.[0]?.error_msg}
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : remitterAccountDetailsData?.approval_status ===
                          "pending" ? (
                          <>
                            <div
                              // key={account.id}
                              className={`h-full flex justify-end w-full ${
                                remitterAccountDetailsData?.approval_status ===
                                  "approved" &&
                                services?.find(
                                  (service) =>
                                    service === "REAAccount" ||
                                    service === "Admin",
                                ) !== undefined
                                  ? "bg-Button-green hover:opacity-dark-opacity"
                                  : remitterAccountDetailsData?.approval_status ===
                                      "approved"
                                    ? "bg-Button-green"
                                    : ""
                              } `}
                            >
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Reject <br /> account
                                  </>
                                }
                                handleFunction={() => {
                                  if (
                                    services?.find(
                                      (service) =>
                                        (service === "REAAccount" ||
                                          service === "Admin") &&
                                        hasUnmatchPermission,
                                    ) !== undefined
                                  ) {
                                    if (!loadingState) {
                                      setRejectAccountLoader(true);
                                      setApproveAccount(false);
                                      handleDeclinedDetials(
                                        id || rem_account_id,
                                      );
                                    }
                                  } else if (
                                    services?.find(
                                      (service) =>
                                        service === "REAAccount" ||
                                        service === "Admin",
                                    ) !== undefined &&
                                    (remitterAccountDetailsData?.mapped_consolidated_statement_entries_count ===
                                      GlobalConfiguration.lengthCheckZero ||
                                      remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count ===
                                        GlobalConfiguration.lengthCheckZero)
                                  ) {
                                    if (!loadingState) {
                                      setRejectAccountLoader(true);
                                      setApproveAccount(false);
                                      handleDeclinedDetials(
                                        id || rem_account_id,
                                      );
                                    }
                                  } else if (
                                    (remitterAccountDetailsData?.mapped_consolidated_statement_entries_count >
                                      GlobalConfiguration.lengthCheckZero ||
                                      remitterAccountDetailsData?.mapped_itemised_consolidated_statement_entries_count >
                                        GlobalConfiguration.lengthCheckZero) &&
                                    !hasUnmatchPermission
                                  ) {
                                    setIsService(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "REAAccount",
                                      },
                                    });
                                  }
                                }}
                                icon={ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE}
                                enabledBgColor={"var(--negative-act)"}
                                isDisabled={
                                  loadingState
                                    ? true
                                    : !services?.find(
                                        (service) =>
                                          service === "REAAccount" ||
                                          service === "Admin",
                                      )
                                }
                                enabledTextColor={"var(--text-primary"}
                                hoverOption="black"
                                fullWidthRequired={isMobile}
                              />

                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Approve <br /> account
                                  </>
                                }
                                isDisabled={
                                  loadingState
                                    ? true
                                    : !services?.find(
                                        (service) =>
                                          service === "REAAccount" ||
                                          service === "Admin",
                                      )
                                }
                                handleFunction={() => {
                                  if (
                                    services?.find(
                                      (service) =>
                                        service === "REAAccount" ||
                                        service === "Admin",
                                    ) !== undefined
                                  ) {
                                    if (!loadingState) {
                                      setselectCardLive(false);
                                      setselectCardBank(false);
                                      setRejectAccount(false);
                                      handleApprovalDetails(
                                        remitterAccountDetailsData?.id,
                                      );
                                    }
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "REAAccount",
                                      },
                                    });
                                  }
                                }}
                                icon={ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK}
                                enabledBgColor={"var(--positive-act)"}
                                enabledTextColor={"var(--text-primary"}
                                hoverOption="black"
                                fullWidthRequired={isMobile}
                              />
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-primary-card mt-margin-sm flex flex-col Qsmd:hidden">
                <div className="bg-primary-card w-width-full px-padding-md py-padding-sm">
                  <p
                    style={{
                      fontWeight: "var(--font-semibold)",
                      letterSpacing: "var(--letter-space)",
                    }}
                    className="text-text-primary text-font-md font-normal"
                  >
                    Quick Actions
                  </p>
                </div>
                <div className="flex w-full">
                  <div className="w-width-md">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Match in bank <br /> statement
                        </>
                      }
                      handleFunction={() => {
                        if (popup) {
                          actionRestricted();
                          return;
                        }

                        if (hasMatchPermission) {
                          if (
                            remitterAccountDetailsData?.approval_status ===
                              "archived" ||
                            remitterAccountDetailsData?.approval_status ===
                              "rejected"
                          ) {
                            CommonToast({
                              text: isArchivedAccount
                                ? "Action restricted for archived account. Unarchive it to enable this action."
                                : "Action restricted for rejected account. Edit it to enable this action.",
                              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                              variant: "var(--error)",
                            });
                            return;
                          }

                          if (!loadingState) {
                            navigate(
                              "/owner_account_dashboard/consolidated_bank_statement",
                              {
                                state: {
                                  statementid: ConsolidatedBankTotalId,
                                  data: id,
                                  remName: remitterAccountDetailsData?.name,
                                  flow: "remitter_details_match_statement",
                                },
                              },
                            );
                          }
                        } else {
                          const requiredServices = [
                            "AMapping",
                            "VAccountBalance",
                          ];

                          const unavailableServices = requiredServices.filter(
                            (service) => !services?.includes(service),
                          );

                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: unavailableServices,
                            },
                          });
                        }
                      }}
                      isDisabled={
                        loadingState ||
                        !hasMatchPermission ||
                        popup ||
                        isArchivedAccount ||
                        isRejectAccount
                      }
                      imgColor="var(--text-primary)"
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      hoverOption="white"
                      icon={ICONS?.MATCHED_WITH_CIRCLE}
                      fullWidthRequired={true}
                    />
                  </div>
                  <div className="border-r border-primary-bg my-margin-md"></div>
                  <div className="w-width-md">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Match in live <br /> statement
                        </>
                      }
                      handleFunction={() => {
                        if (popup) {
                          actionRestricted();
                          return;
                        }

                        if (hasLiveMatchPermission) {
                          if (
                            remitterAccountDetailsData?.approval_status ===
                              "archived" ||
                            remitterAccountDetailsData?.approval_status ===
                              "rejected"
                          ) {
                            CommonToast({
                              text: isArchivedAccount
                                ? "Action restricted for archived account. Unarchive it to enable this action."
                                : "Action restricted for rejected account. Edit it to enable this action.",
                              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                              variant: "var(--error)",
                            });
                            return;
                          }

                          handleMatchClickLive();
                        } else {
                          const requiredServices = [
                            "AMapping",
                            "VItemisedStatement",
                          ];

                          const unavailableServices = requiredServices.filter(
                            (service) => !services?.includes(service),
                          );

                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: unavailableServices,
                            },
                          });
                        }
                      }}
                      isDisabled={
                        loadingState ||
                        !hasMatchPermission ||
                        popup ||
                        isArchivedAccount ||
                        isRejectAccount
                      }
                      imgColor="var(--text-primary)"
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      hoverOption="white"
                      icon={ICONS?.MATCHED_WITH_CIRCLE}
                      fullWidthRequired={true}
                    />
                  </div>
                </div>
                <div className="border-b border-solid border-primary-bg"></div>
                <div className="flex">
                  <div className="w-width-md">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Edit <br /> account
                        </>
                      }
                      handleFunction={() => {
                        if (popup) {
                          actionRestricted();
                        } else {
                          if (
                            remitterAccountDetailsData?.approval_status !==
                            "archived"
                          ) {
                            if (hasEditPermission) {
                              if (!loadingState) {
                                navigate(
                                  `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/edit_account_details/${id}`,
                                );
                              }
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "REUAccount",
                                },
                              });
                            }
                          }
                        }
                      }}
                      isDisabled={popup || !hasEditPermission}
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                      hoverOption="white"
                      fullWidthRequired={true}
                    />
                  </div>
                  <div className="border-r border-primary-bg my-margin-md"></div>
                  <div className="w-width-md">
                    <TopNavSmallButton
                      btnText={
                        remitterAccountDetailsData?.approval_status ===
                        "archived" ? (
                          <>
                            Unarchive <br /> account
                          </>
                        ) : (
                          <>
                            Archive <br /> account
                          </>
                        )
                      }
                      isDisabled={
                        popup ||
                        !services?.find(
                          (service) =>
                            service === "REAAccountArchive" ||
                            service === "Admin",
                        )
                      }
                      handleFunction={() => {
                        const hasPermission = services?.some(
                          (service) =>
                            service === "REAAccountArchive" ||
                            service === "Admin",
                        );

                        if (popup) {
                          actionRestricted();
                          return;
                        }

                        if (hasPermission) {
                          if (!loadingState) {
                            handleUnArchive();
                            handleArchive();
                          }
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "REAAccountArchive",
                            },
                          });
                        }
                      }}
                      icon={
                        remitterAccountDetailsData?.approval_status ===
                        "archived"
                          ? ICONS?.UNARCHIVE
                          : ICONS?.ARCHIVE
                      }
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      hoverOption="white"
                      fullWidthRequired={true}
                    />
                  </div>
                </div>
              </div>

              <div
                className={`bg-primary-bg relative w-full overflow-x-hidden flex flex-col ${(liveLoader || bankLoader) && "flex-1"}`}
              >
                <div className="w-full bg-primary-card">
                  <div className="w-full lg:w-max-content-width m-auto">
                    <CommonAlertsStrip alerts={buildAlerts()} />
                  </div>
                </div>

                <div className="w-full top-top-base bg-primary-bg pt-padding-md   px-padding-sm lg::px-padding-base">
                  <div className="h-fit lg:mx-auto max-w-tab-width-normal flex flex-col lg:flex-row gap-x-gap-md justify-between bg-primary-bg w-full">
                    <div className="no-scrollbar overflow-x-auto">
                      <SwitcherTabs
                        tabs={[
                          {
                            label: hasBankStatementPermission
                              ? `Consolidated bank statement (${bankStatementCount}) `
                              : "Consolidated bank statement (N/A)",
                            key: "Consolidated bank statement",
                            isDisabled: false,
                            handler: () => {
                              setIndex(GlobalConfiguration.lengthCheckZero);
                              setCurrentPage(
                                GlobalConfiguration.lengthCheckOne,
                              );
                              if (
                                !isBankApiCalled &&
                                flow !== "match_transaction" &&
                                popup
                              ) {
                                handleFetchPagination();
                                setIsBankApiCalled(true);
                              }
                              setSelectedValue(
                                PaginationConfiguration.paginationSmall,
                              );
                              setPageSize(
                                PaginationConfiguration.paginationSmall,
                              );
                              setselectCardLive(false);
                              setConsolidatedLive([]);
                            },
                          },
                          {
                            label: hasLiveStatementPermission
                              ? `Consolidated live statement (${liveStatementCount}) `
                              : "Consolidated live statement (N/A)",
                            key: "Consolidated live statement",
                            isDisabled: false,
                            handler: () => {
                              setIndex(GlobalConfiguration.lengthCheckOne);
                              setLiveCurrentPage(
                                GlobalConfiguration.lengthCheckOne,
                              );
                              setselectCardBank(false);
                              if (!isLiveApiCalled) {
                                setIsLiveApiCalled(true);
                                handleLiveFetchPagination();
                              }
                              setConsolidatedBank([]);
                              setSelectedLiveValue(
                                PaginationConfiguration.paginationSmall,
                              );
                              setLivePageSize(
                                PaginationConfiguration.paginationSmall,
                              );
                            },
                          },
                          {
                            label: "Account details",
                            key: "Account details",
                            handler: () => {
                              setIndex(GlobalConfiguration.lengthCheckTwo);
                              setselectCardBank(false);
                              setselectCardLive(false);
                            },
                          },

                          {
                            label: "Labels",
                            key: "Labels",
                            handler: () => {
                              setIndex(GlobalConfiguration.lengthCheckThree);
                              setselectCardBank(false);
                              setselectCardLive(false);
                            },
                          },
                          {
                            label: "Support details",
                            key: "Support details",
                            handler: () => {
                              setIndex(GlobalConfiguration.lengthCheckFour);
                              setselectCardBank(false);
                              setselectCardLive(false);
                            },
                          },
                        ]}
                        swicherTabBgColor={"var(--primary-card)"}
                        setIndex={setIndex}

                        initialActiveTab={
                          index === GlobalConfiguration.lengthCheckTwo
                            ? "Account details"
                            : index === GlobalConfiguration.lengthCheckFour
                              ? "Support details"
                              : index === GlobalConfiguration.lengthCheckThree
                                ? "Labels"
                                : index === GlobalConfiguration.lengthCheckZero
                                  ? "Consolidated bank statement"
                                  : index === GlobalConfiguration.lengthCheckOne
                                    ? "Consolidated live statement"
                                    : ""
                        }
                      />
                    </div>

                    <div
                      className={` mt-margin-md lg:mt-margin-base ${index === GlobalConfiguration.lengthCheckZero && consolidatedPaginationData?.statement?.length > GlobalConfiguration.lengthCheckZero ? "block" : "hidden"}`}
                    >
                      <PrimaryRightIconFill
                        btnText={selectCardBank ? "Cancel" : "Bulk unmatch"}
                        enabledBgColor={` ${selectCardBank ? "var(--primary-nav-act)" : "var(--negative-act)"}`}
                        isDisabled={
                          popup
                            ? true
                            : loadingState
                              ? true
                              : !hasUnmatchPermission
                                ? true
                                : remitterAccountDetailsData?.approval_status ===
                                    "archived"
                                  ? true
                                  : false
                        }
                        handleFunction={() => {
                          if (hasUnmatchPermission) {
                            if (popup) {
                              actionRestricted();
                            } else if (
                              remitterAccountDetailsData?.approval_status !==
                                "archived" &&
                              !popup
                            ) {
                              if (!loadingState) {
                                handleToggleBankSelect();
                              }
                            } else {
                              CommonToast({
                                text: "Action restricted for archived account. Unarchive it to enable this action.",
                                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                variant: "var(--error)",
                              });
                            }
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "RMapping",
                              },
                            });
                          }
                        }}
                        iconToBeAlign="right"
                        imgColor={
                          !selectCardBank ? "var(--text-primary)" : undefined
                        }
                        enabledTextColor={"var(--text-primary)"}
                        icon={
                          selectCardBank
                            ? ICONS.CLOSE_WITH_WHITE_CIRCLE
                            : ICONS.UNMATCHED_WITH_CIRCLE
                        }
                        fullWidthRequired={false}
                        hoverOption={`${selectCardBank ? "white" : "black"}`}
                      />
                    </div>

                    <div
                      className={`mt-margin-md lg:mt-margin-base ${index === GlobalConfiguration.lengthCheckOne && livePaginationData?.ecollection_callbacks?.length > GlobalConfiguration.lengthCheckZero ? "block" : "hidden"}`}
                    >
                      <PrimaryRightIconFill
                        btnText={selectCardLive ? "Cancel" : "Bulk unmatch"}
                        enabledBgColor={` ${selectCardLive ? "var(--primary-nav-act)" : "var(--negative-act)"}`}
                        isDisabled={
                          popup
                            ? true
                            : loadingState
                              ? true
                              : !hasUnmatchPermission
                                ? true
                                : remitterAccountDetailsData?.approval_status ===
                                    "archived"
                                  ? true
                                  : false
                        }
                        handleFunction={() => {
                          if (hasUnmatchPermission) {
                            if (popup) {
                              actionRestricted();
                            } else if (
                              remitterAccountDetailsData?.approval_status !==
                                "archived" &&
                              !popup
                            ) {
                              if (!loadingState) {
                                handleToggleLiveSelect();
                              }
                            } else {
                              CommonToast({
                                text: "Action restricted for archived account. Unarchive it to enable this action.",
                                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                variant: "var(--error)",
                              });
                            }
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "RMapping",
                              },
                            });
                          }
                        }}
                        iconToBeAlign="right"
                        enabledTextColor={"var(--text-primary)"}
                        icon={
                          selectCardLive
                            ? ICONS.CLOSE_WITH_WHITE_CIRCLE
                            : ICONS.UNMATCHED_WITH_CIRCLE
                        }
                        fullWidthRequired={false}
                        hoverOption={`${selectCardLive ? "white" : "black"}`}
                        imgColor={
                          !selectCardLive ? "var(--text-primary)" : undefined
                        }
                      />
                    </div>
                  </div>
                </div>
                {index === GlobalConfiguration?.lengthCheckFour && (
                  <div className={animationClass}>
                    <div
                      className={`max-w-tab-width-normal mx-auto no-scrollbar`}
                    >
                      {true &&
                        (() => {
                          let originItemList = [
                            {
                              content:
                                remitterAccountDetailsData?.created_by_name
                                  ? remitterAccountDetailsData?.created_by_name
                                  : "Not given",
                              heading: "Created by",
                              type: "text",
                            },
                            {
                              content: remitterAccountDetailsData?.created_on
                                ? formatDateViewAll(
                                    remitterAccountDetailsData?.created_on,
                                    true,
                                    true,
                                  )
                                : "Not given",
                              heading: "Created on",
                              type: "text",
                            },
                            ...(remitterAccountDetailsData?.approval_status ===
                            "approved"
                              ? [
                                  {
                                    content:
                                      remitterAccountDetailsData?.approved_by_name ||
                                      "Not given",
                                    heading: "Approved by",
                                    type: "text",
                                  },
                                  {
                                    content:
                                      remitterAccountDetailsData?.approved_on
                                        ? formatDateViewAll(
                                            remitterAccountDetailsData?.approved_on,
                                            true,
                                            true,
                                          )
                                        : "Not given",
                                    heading: "Approved on",
                                    type: "text",
                                  },
                                ]
                              : []),

                            // ✅ REJECTED
                            ...(remitterAccountDetailsData?.approval_status ===
                            "rejected"
                              ? [
                                  {
                                    content:
                                      remitterAccountDetailsData?.rejected_by_name ||
                                      "Not given",
                                    heading: "Rejected by",
                                    type: "text",
                                  },
                                  {
                                    content:
                                      remitterAccountDetailsData?.rejected_on
                                        ? formatDateViewAll(
                                            remitterAccountDetailsData?.rejected_on,
                                            true,
                                            true,
                                          )
                                        : "Not given",
                                    heading: "Rejected on",
                                    type: "text",
                                  },
                                  {
                                    content:
                                      remitterAccountDetailsData?.rejection_reason ||
                                      "Not given",
                                    heading: "Rejected reason",
                                    type: "text",
                                  },
                                ]
                              : []),

                            // ✅ ARCHIVED
                            ...(remitterAccountDetailsData?.approval_status ===
                            "archived"
                              ? [
                                  {
                                    content:
                                      remitterAccountDetailsData?.archived_by_name ||
                                      "Not given",
                                    heading: "Archived by",
                                    type: "text",
                                  },
                                  {
                                    content:
                                      remitterAccountDetailsData?.archived_on
                                        ? formatDateViewAll(
                                            remitterAccountDetailsData?.archived_on,
                                            true,
                                            true,
                                          )
                                        : "Not given",
                                    heading: "Archived on",
                                    type: "text",
                                  },
                                ]
                              : []),
                          ];

                          let supportItemList = [
                            {
                              content: remitterAccountDetailsData?.id
                                ? remitterAccountDetailsData?.id
                                : "Not given",
                              heading: "Account ID",
                              type: "textWithButton",
                              iconArray: [
                                {
                                  icon:
                                    copiedField === "account_id"
                                      ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                      : ICONS.COPY,
                                  bgColor: "var(--text-primary)",
                                  title:
                                    copiedField === "account_id"
                                      ? "Copied"
                                      : "Copy to clipboard",
                                  onClick: () => {
                                    setCopiedField("account_id");
                                    navigator.clipboard.writeText(
                                      remitterAccountDetailsData?.id,
                                    );

                                    setTimeout(() => {
                                      setCopiedField("");
                                    }, IntervalConfiguration.intervalMedium);
                                  },
                                },
                              ],
                            },
                          ];

                          return (
                            <div
                              className={`flex flex-col lg:flex-row my-margin-md px-padding-md lg:px-padding-base ${
                                false
                                  ? "justify-between gap-gap-md"
                                  : "gap-gap-md lg:gap-gap-md"
                              }`}
                            >
                              <CommonDetailCard
                                cardTitle={TEXT?.ORIGIN_DETAILS}
                                variant="third"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                entries={originItemList}
                              />

                              <CommonDetailCard
                                cardTitle={"Support Details"}
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={supportItemList}
                              />
                            </div>
                          );
                        })()}
                    </div>
                  </div>
                )}

                {index === GlobalConfiguration?.lengthCheckTwo && (
                  <div className={animationClass}>
                    <div
                      className={`max-w-tab-width-normal mx-auto no-scrollbar`}
                    >
                      {true &&
                        (() => {
                          let originItemList = [
                            {
                              content: remitterAccountDetailsData?.account_type,
                              heading: "Account state",
                              type: "text",
                            },
                          ];

                          return (
                            <div
                              className={`flex flex-col lg:flex-row my-margin-md px-padding-md lg:px-padding-base ${
                                false
                                  ? "justify-between gap-gap-md"
                                  : "gap-gap-md lg:gap-gap-md"
                              }`}
                            >
                              <CommonDetailCard
                                cardTitle={TEXT?.ACCOUNT_DETAILS}
                                variant="third"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                entries={originItemList}
                              />
                            </div>
                          );
                        })()}
                    </div>
                  </div>
                )}

                {index === GlobalConfiguration?.lengthCheckThree && (
                  <div className={animationClass}>
                    <div
                      style={{
                        scrollbarWidth: "none",
                      }}
                      className="mt-margin-md mb-margin-md lg:mx-auto overflow-x-hidden max-w-tab-width-normal"
                    >
                      <CommonContainerCard
                        header="Labels"
                        iconIsDisabled={popup || loadingState}
                        subheader={
                          "These will be used to generate statistics for the associated accounts."
                        }
                        icon={ICONS?.EDIT}
                        handleFunction={(e) => {
                          if (popup) {
                            actionRestricted();
                          } else {
                            if (!loadingState) {
                              setShowLabelsPopup(true);
                            }
                          }
                        }}
                      >
                        <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                          {Array.isArray(labelDetails) &&
                          labelDetails?.length >
                            GlobalConfiguration.lengthCheckZero ? (
                            <>
                              {labelDetails?.map((item, index) => (
                                <Chips
                                  key={index}
                                  txtChip={item}
                                  enabledBgColor="var(--primary-nav)"
                                  disableIcon={false}
                                  handleFunctionBtn={() => {
                                    if (popup) {
                                      actionRestricted();
                                    } else {
                                      if (!loadingState) {
                                        setOpenLabelSearchPopup(true);
                                        setLabelName(item);
                                      }
                                    }
                                  }}
                                  hoverOptionBtn="white"
                                  isDisabled={loadingState}
                                  enabledTextColor="var(--text-primary)"
                                />
                              ))}
                            </>
                          ) : (
                            <p className="text-font-sm text-text-primary">
                              Not assigned.
                            </p>
                          )}
                        </div>
                      </CommonContainerCard>
                    </div>
                  </div>
                )}

                {index === GlobalConfiguration.lengthCheckZero && (
                  <>
                    <div
                      style={{ flex: bankLoader && "1" }}
                      className={animationClass}
                    >
                      {hasBankStatementPermission &&
                      consolidatedPaginationData?.statement?.length >
                        GlobalConfiguration.lengthCheckZero &&
                      !bankLoader ? (
                        <div className="pt-padding-md">
                          {!bankLoader && selectCardBank && (
                            <>
                              {" "}
                              <div
                                ref={bankBarRef}
                                className={`lg:mx-auto absolute w-width-full flex justify-center z-z-index-content transition-all duration-animation-fast ease-in-out ${selectCardBank ? "opacity-base-opacity" : "opacity-light-opacity"}`}
                              >
                                <div className="flex bg-primary-nav px-padding-md flex-wrap justify-between rounded-border-radius-md max-w-tab-width-normal w-width-full mx-margin-sm">
                                  <div className="text-font-xs text-text-primary pr-padding-md Qsmd:pr-padding-base my-margin-sm flex items-center">
                                    {`Transactions selected on current page : ${consolidatedBank.length} `}
                                  </div>
                                  <div className="flex gap-gap-sm">
                                    <div className="my-margin-sm">
                                      <SecondaryRightIconSmallButton
                                        btnText={`Select up to ${selectedValue}`}
                                        btnType="button"
                                        handleFunction={() => {
                                          if (!loadingState) {
                                            handleSelectAll(
                                              consolidatedBank,
                                              setConsolidatedBank,
                                              selectedValue,
                                              consolidatedPaginationData?.statement,
                                              "account_statement_entry_id",
                                            );
                                          }
                                        }}
                                        isDisabled={loadingState}
                                        enabledTextColor="var(--text-primary)"
                                        enabledBgColor={
                                          isAllSelected
                                            ? "var(--positive-bg)"
                                            : "var(--primary-nav-act)"
                                        }
                                        hoverOption={
                                          isAllSelected ? "black" : "white"
                                        }
                                        icon={
                                          isAllSelected
                                            ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                            : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                                        }
                                      />
                                    </div>

                                    <div className="my-margin-sm">
                                      <PrimaryButton
                                        enabledBgColor={
                                          consolidatedBank?.length >
                                          GlobalConfiguration.lengthCheckZero
                                            ? "var(--text-primary)"
                                            : "var(--text-disabled)"
                                        }
                                        inActiveVariantNeeded={
                                          loadingState
                                            ? false
                                            : consolidatedLive?.length >
                                                GlobalConfiguration.lengthCheckZero
                                              ? false
                                              : true
                                        }
                                        isDisabled={
                                          loadingState
                                            ? true
                                            : consolidatedBank?.length >
                                                GlobalConfiguration.lengthCheckZero
                                              ? false
                                              : true
                                        }
                                        btnText="Unmatch"
                                        enabledTextColor={
                                          consolidatedBank?.length >
                                          GlobalConfiguration.lengthCheckZero
                                            ? "var(--primary_bg)"
                                            : "var(--text-primary)"
                                        }
                                        handleFunction={() => {
                                          const hasPermission = services?.some(
                                            (service) =>
                                              service === "RMapping" ||
                                              service === "Admin",
                                          );

                                          if (popup) {
                                            actionRestricted();
                                            return;
                                          }
                                          if (!loadingState) {
                                            if (hasPermission) {
                                              if (
                                                consolidatedBank?.length >
                                                GlobalConfiguration.lengthCheckZero
                                              ) {
                                                setUnmatchStatementPopup(true);
                                              }
                                            } else {
                                              navigate(
                                                "/feature_not_assigned",
                                                {
                                                  state: {
                                                    unavailableService:
                                                      "RMapping",
                                                  },
                                                },
                                              );
                                            }
                                          }
                                        }}
                                        hoverOption={
                                          consolidatedBank?.length >
                                          GlobalConfiguration.lengthCheckZero
                                            ? "black"
                                            : "white"
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          <div
                            ref={(el) => {
                              scrollContainerRef.current = el;
                              scrollBankRef.current = el;
                            }}
                            className="bg-primary-bg relative z-z-index-header transition-all duration-animation-fast ease-in-out overflow-y-auto flex-1 h-full flex standard-card-alignment !pt-padding-base gap-x-gap-sm gap-y-gap-md"
                            style={{
                              // marginBottom: "var(--pagination-height)",
                              marginTop: selectCardBank
                                ? `${bankBarHeight}px`
                                : undefined,
                            }}
                          >
                            {consolidatedPaginationData?.statement?.map(
                              (transactions) => {
                                return (
                                  <CardContainer
                                    key={
                                      transactions?.account_statement_entry_id
                                    }
                                    isInActiveVaraint={popup}
                                    isDisabled={popup}
                                    isSelected={
                                      Array.isArray(consolidatedBank) &&
                                      consolidatedBank?.some(
                                        (item) =>
                                          item?.account_statement_entry_id ===
                                          transactions?.account_statement_entry_id,
                                      )
                                    }
                                    onClickHandler={() => {
                                      if (popup) {
                                        actionRestricted();
                                      } else {
                                        if (selectCardBank) {
                                          handleCardClick(transactions);
                                        } else {
                                          setStatementId(
                                            String(
                                              transactions?.account_statement_entry_id,
                                            ),
                                          );
                                          setViewstatementOpenPop(true);
                                        }
                                      }
                                    }}
                                  >
                                    <card-body>
                                      <TextWithIcon
                                        type={"Amount"}
                                        fontWeight={"semibold"}
                                        text={transactions?.amount}
                                        subText={"Amount"}
                                        textColor={"var(--settled)"}
                                        iconComponentArray={[
                                          ...(true
                                            ? [
                                                {
                                                  icon:
                                                    Array.isArray(
                                                      consolidatedBank,
                                                    ) &&
                                                    consolidatedBank?.some(
                                                      (item) =>
                                                        item?.account_statement_entry_id ===
                                                        transactions?.account_statement_entry_id,
                                                    )
                                                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                                      : selectCardBank
                                                        ? ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                                                        : ICONS.UNMATCH,
                                                  isDisabled: popup
                                                    ? true
                                                    : remitterAccountDetailsData?.approval_status ===
                                                          "archived" ||
                                                        remitterAccountDetailsData?.approval_status ===
                                                          "rejected"
                                                      ? true
                                                      : !hasUnmatchPermission
                                                        ? true
                                                        : false,
                                                  imgColor: !selectCardBank
                                                    ? "var(--text-primary)"
                                                    : undefined,
                                                  title: "Unmatch",
                                                  onClick: () => {
                                                    if (!selectCardBank) {
                                                      if (popup) {
                                                        actionRestricted();
                                                        return;
                                                      }
                                                      setConsolidatedBank([
                                                        String(
                                                          transactions?.account_statement_entry_id,
                                                        ),
                                                      ]);
                                                      if (
                                                        hasUnmatchPermission
                                                      ) {
                                                        if (
                                                          remitterAccountDetailsData?.approval_status ===
                                                            "archived" ||
                                                          remitterAccountDetailsData?.approval_status ===
                                                            "rejected"
                                                        ) {
                                                          CommonToast({
                                                            text: isArchivedAccount
                                                              ? "Action restricted for archived account. Unarchive it to enable this action."
                                                              : "Action restricted for rejected account. Edit it to enable this action.",
                                                            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                                            variant:
                                                              "var(--error)",
                                                          });
                                                        } else {
                                                          setUnmatchStatementPopup(
                                                            true,
                                                          );
                                                        }
                                                      } else {
                                                        navigate(
                                                          "/feature_not_assigned",
                                                          {
                                                            state: {
                                                              unavailableService:
                                                                "RMapping",
                                                            },
                                                          },
                                                        );
                                                      }
                                                    } else {
                                                      handleCardClick(
                                                        transactions,
                                                      );
                                                    }
                                                  },
                                                  bgColor:
                                                    !selectCardBank &&
                                                    "var(--primary-nav)",
                                                },
                                              ]
                                            : []),
                                        ]}
                                      />

                                      <TextWithIcon
                                        text={
                                          transactions?.name
                                            ?.toLowerCase()
                                            ?.split(" ")
                                            ?.map(
                                              (word) =>
                                                word.charAt(0).toUpperCase() +
                                                word.slice(1),
                                            )
                                            ?.join(" ") || "Not given"
                                        }
                                        type={"Text"}
                                        subText={"Name"}
                                        fontWeight={"normal"}
                                        textColor={"var(--text-primary)"}
                                      />

                                      <TextWithBank
                                        text={
                                          transactions?.transaction_date
                                            ? `${new Date(
                                                transactions.transaction_date,
                                              ).getDate()} ${new Date(
                                                transactions.transaction_date,
                                              ).toLocaleString("en-GB", {
                                                month: "short",
                                              })}, ${new Date(
                                                transactions.transaction_date,
                                              ).getFullYear()}`
                                            : "Not given"
                                        }
                                        subText={"Transaction date"}
                                        type={"Text"}
                                        ifscCode={transactions?.ifsc_code}
                                      />
                                    </card-body>
                                  </CardContainer>
                                );
                              },
                            )}
                          </div>
                          <div className="h-breadcrumb-height hidden"></div>
                        </div>
                      ) : hasBankStatementPermission &&
                        consolidatedPaginationData?.total_count ===
                          GlobalConfiguration.lengthCheckZero &&
                        !bankLoader ? (
                        <>
                          <div className="w-full max-w-tab-width-normal mx-auto my-margin-md">
                            <CommonContainerCard
                              header="No transactions have been matched yet."
                              iconIsDisabled={true}
                              handleFunction={(e) => {
                                navigate(
                                  "/owner_account_dashboard/consolidated_bank_statement",
                                  {
                                    state: {
                                      data: id,
                                      flow: "new_match_txn",
                                      remName: remitterAccountDetailsData?.name,
                                    },
                                  },
                                );
                              }}
                            >
                              <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                                <Chips
                                  key={index}
                                  isDisabled={
                                    popup ||
                                    loadingState ||
                                    !hasMatchPermission ||
                                    isArchivedAccount ||
                                    isRejectAccount
                                  }
                                  txtChip={"Match transactions"}
                                  enabledBgColor="var(--primary-nav)"
                                  hoverOption={"white"}
                                  hoverOptionBtn="white"
                                  handleFunctionBtn={() => {
                                    if (popup) {
                                      actionRestricted();
                                    } else if (loadingState) {
                                      return;
                                    } else {
                                      if (hasMatchPermission) {
                                        if (
                                          isArchivedAccount ||
                                          isRejectAccount
                                        ) {
                                          CommonToast({
                                            text: isArchivedAccount
                                              ? "Action restricted for archived account. Unarchive it to enable this action."
                                              : "Action restricted for rejected account. Edit it to enable this action.",
                                            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                            variant: "var(--error)",
                                          });
                                        } else {
                                          navigate(
                                            "/owner_account_dashboard/consolidated_bank_statement",
                                            {
                                              state: {
                                                data: id,
                                                flow: "new_match_txn",
                                                remName:
                                                  remitterAccountDetailsData?.name,
                                              },
                                            },
                                          );
                                        }
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "AMapping",
                                          },
                                        });
                                      }
                                    }
                                  }}
                                  enabledTextColor="var(--text-primary)"
                                />
                              </div>
                            </CommonContainerCard>
                          </div>
                        </>
                      ) : !hasBankStatementPermission && !bankLoader ? (
                        <>
                          <div className="w-full max-w-tab-width-normal px-padding-md Qsmd:px-padding-base mx-auto my-margin-md">
                            {" "}
                            <div className=" bg-primary-card p-padding-md rounded-border-radius-md">
                              <p className="  text-font-sm font-normal text-text-primary  ">
                                Service not assigned to your role.
                              </p>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className=" flex-1">
                            {" "}
                            <div
                              className={`absolute top-top-base z-z-index-fixed-ui h-height-full w-width-full flex justify-center items-center`}
                            >
                              <Loader />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}

                {index === GlobalConfiguration.lengthCheckOne && (
                  <>
                    <div
                      className={animationClass}
                      style={{ flex: liveLoader && "1" }}
                    >
                      {hasLiveStatementPermission &&
                      livePaginationData?.ecollection_callbacks?.length >
                        GlobalConfiguration.lengthCheckZero &&
                      !liveLoader ? (
                        <div className="pt-padding-md">
                          {!liveLoader && selectCardLive && (
                            <>
                              {" "}
                              <div
                                ref={liveBarRef}
                                className={`lg:mx-auto absolute w-width-full flex justify-center z-z-index-content ${selectCardLive ? "opacity-base-opacity" : "opacity-light-opacity"}  transition-all duration-animation-fast ease-in-out`}
                              >
                                <div className="flex bg-primary-nav px-padding-md flex-wrap justify-between rounded-border-radius-md max-w-tab-width-normal w-width-full mx-margin-sm">
                                  <div className="text-font-xs text-text-primary pr-padding-md lg:pr-padding-base my-margin-sm flex items-center">
                                    {`Transactions selected on current page : ${consolidatedLive?.length} `}
                                  </div>
                                  <div className="flex gap-gap-sm">
                                    <div className="my-margin-sm">
                                      <SecondaryRightIconSmallButton
                                        btnText={`Select up to ${selectedLiveValue}`}
                                        btnType="button"
                                        handleFunction={() => {
                                          if (!loadingState) {
                                            handleSelectAll(
                                              consolidatedLive,
                                              setConsolidatedLive,
                                              selectedLiveValue,
                                              livePaginationData?.ecollection_callbacks,
                                              "ecollection_callback_id",
                                            );
                                          }
                                        }}
                                        isDisabled={loadingState}
                                        enabledTextColor="var(--text-primary)"
                                        enabledBgColor={
                                          isAllSelectedLive
                                            ? "var(--positive-bg)"
                                            : "var(--primary-nav-act)"
                                        }
                                        hoverOption={
                                          isAllSelectedLive ? "black" : "white"
                                        }
                                        icon={
                                          isAllSelectedLive
                                            ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                            : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                                        }
                                      />
                                    </div>
                                    <div className="my-margin-sm">
                                      <PrimaryButton
                                        enabledBgColor={
                                          consolidatedLive?.length >
                                          GlobalConfiguration.lengthCheckZero
                                            ? "var(--text-primary)"
                                            : "var(--text-disabled)"
                                        }
                                        inActiveVariantNeeded={
                                          loadingState
                                            ? false
                                            : consolidatedLive?.length >
                                                GlobalConfiguration.lengthCheckZero
                                              ? false
                                              : true
                                        }
                                        btnText="Unmatch"
                                        isDisabled={
                                          loadingState
                                            ? true
                                            : consolidatedLive?.length >
                                                GlobalConfiguration.lengthCheckZero
                                              ? false
                                              : true
                                        }
                                        enabledTextColor={
                                          consolidatedLive?.length >
                                          GlobalConfiguration.lengthCheckZero
                                            ? "var(--primary_bg)"
                                            : "var(--text-primary)"
                                        }
                                        handleFunction={() => {
                                          const hasPermission = services?.some(
                                            (service) =>
                                              service === "RMapping" ||
                                              service === "Admin",
                                          );

                                          if (popup) {
                                            actionRestricted();
                                            return;
                                          }

                                          if (!loadingState) {
                                            if (hasPermission) {
                                              if (
                                                consolidatedLive?.length >
                                                GlobalConfiguration.lengthCheckZero
                                              ) {
                                                setUnmatchStatementPopup(true);
                                              }
                                            } else {
                                              navigate(
                                                "/feature_not_assigned",
                                                {
                                                  state: {
                                                    unavailableService:
                                                      "RMapping",
                                                  },
                                                },
                                              );
                                            }
                                          }
                                        }}
                                        hoverOption={
                                          consolidatedLive?.length >
                                          GlobalConfiguration.lengthCheckZero
                                            ? "black"
                                            : "white"
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          <div
                            ref={(el) => {
                              scrollContainerRef.current = el;
                              scrollLiveRef.current = el;
                            }}
                            style={{
                              // marginBottom: "var(--pagination-height)",
                              marginTop: selectCardLive
                                ? `${liveBarHeight}px`
                                : undefined,
                            }}
                            // style={{ marginBottom: "var(--pagination-height)" }}
                            className={`bg-primary-bg relative z-z-index-header transition-all duration-animation-fast  ease-in-out overflow-y-auto flex-1 flex standard-card-alignment !pt-padding-base h-full gap-x-gap-sm gap-y-gap-md`}
                          >
                            {livePaginationData?.ecollection_callbacks?.map(
                              (transactions) => {
                                return (
                                  <>
                                    <CardContainer
                                      key={
                                        transactions?.ecollection_callback_id
                                      }
                                      isSelected={
                                        Array.isArray(consolidatedLive) &&
                                        consolidatedLive?.some(
                                          (item) =>
                                            item?.ecollection_callback_id ===
                                            transactions?.ecollection_callback_id,
                                        )
                                      }
                                      isInActiveVaraint={popup}
                                      isDisabled={popup}
                                      onClickHandler={() => {
                                        if (popup) {
                                          actionRestricted();
                                        } else {
                                          if (selectCardLive) {
                                            handleLiveCardClick(transactions);
                                          } else {
                                            setStatementLiveConsolidatedId([
                                              transactions?.ecollection_callback_id,
                                            ]);
                                            setViewLivestatementOpenPop(true);
                                          }
                                        }
                                      }}
                                    >
                                      <card-body>
                                        <TextWithIcon
                                          type={"Amount"}
                                          fontWeight={"semibold"}
                                          text={transactions?.amount}
                                          subText={"Amount"}
                                          textColor={"var(--settled)"}
                                          iconComponentArray={[
                                            ...(true
                                              ? [
                                                  {
                                                    icon:
                                                      Array.isArray(
                                                        consolidatedLive,
                                                      ) &&
                                                      consolidatedLive?.some(
                                                        (item) =>
                                                          item?.ecollection_callback_id ===
                                                          transactions?.ecollection_callback_id,
                                                      )
                                                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                                        : selectCardLive
                                                          ? ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                                                          : ICONS.UNMATCH,
                                                    isDisabled: popup
                                                      ? true
                                                      : remitterAccountDetailsData?.approval_status ===
                                                            "archived" ||
                                                          remitterAccountDetailsData?.approval_status ===
                                                            "rejected"
                                                        ? true
                                                        : !hasUnmatchPermission
                                                          ? true
                                                          : false,
                                                    title: "Unmatch",
                                                    imgColor: !selectCardLive
                                                      ? "var(--text-primary)"
                                                      : undefined,
                                                    onClick: () => {
                                                      if (!selectCardLive) {
                                                        if (popup) {
                                                          actionRestricted();
                                                          return;
                                                        }
                                                        setConsolidatedLive([
                                                          transactions?.ecollection_callback_id,
                                                        ]);
                                                        if (
                                                          hasUnmatchPermission
                                                        ) {
                                                          if (
                                                            remitterAccountDetailsData?.approval_status ===
                                                              "archived" ||
                                                            remitterAccountDetailsData?.approval_status ===
                                                              "rejected"
                                                          ) {
                                                            CommonToast({
                                                              text: isArchivedAccount
                                                                ? "Action restricted for archived account. Unarchive it to enable this action."
                                                                : "Action restricted for rejected account. Edit it to enable this action.",
                                                              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                                              variant:
                                                                "var(--error)",
                                                            });
                                                          } else {
                                                            setUnmatchStatementPopup(
                                                              true,
                                                            );
                                                          }
                                                        } else {
                                                          navigate(
                                                            "/feature_not_assigned",
                                                            {
                                                              state: {
                                                                unavailableService:
                                                                  "RMapping",
                                                              },
                                                            },
                                                          );
                                                        }
                                                      } else {
                                                        handleLiveCardClick(
                                                          transactions,
                                                        );
                                                      }
                                                    },
                                                    bgColor:
                                                      !selectCardLive &&
                                                      "var(--primary-nav)",
                                                  },
                                                ]
                                              : []),
                                          ]}
                                        />

                                        <TextWithIcon
                                          text={
                                            transactions.party_name
                                              ? transactions.party_name
                                                  .toLowerCase()
                                                  .split(" ")
                                                  .map(
                                                    (word) =>
                                                      word
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                      word.slice(1),
                                                  )
                                                  .join(" ")
                                              : "Not given"
                                          }
                                          type={"Text"}
                                          subText={"Party name"}
                                          fontWeight={"normal"}
                                          textColor={"var(--text-primary)"}
                                        />
                                        <TextWithBank
                                          text={
                                            transactions?.transaction_date
                                              ? (() => {
                                                  const date = new Date(
                                                    transactions.transaction_date *
                                                      1000,
                                                  );
                                                  return `${date.getDate()} ${date.toLocaleString(
                                                    "en-GB",
                                                    {
                                                      month: "short",
                                                    },
                                                  )}, ${date.getFullYear()}`;
                                                })()
                                              : "Not given"
                                          }
                                          subText={"Transaction date"}
                                          type={"Text"}
                                          // src={categoryMapper(
                                          //   transactions.category,
                                          // )}
                                          ifscCode={transactions.ifsc_code}
                                        />
                                      </card-body>
                                    </CardContainer>
                                  </>
                                );
                              },
                            )}
                          </div>
                        </div>
                      ) : hasLiveStatementPermission &&
                        livePaginationData?.total_count ===
                          GlobalConfiguration.lengthCheckZero &&
                        !liveLoader ? (
                        <>
                          <div className="w-full max-w-tab-width-normal mx-auto my-margin-md">
                            <CommonContainerCard
                              header="No transactions have been matched yet."
                              iconIsDisabled={true}
                              new_match_txn
                              handleFunction={(e) => {
                                navigate(
                                  "/owner_account_dashboard/consolidated_bank_statement",
                                  {
                                    state: {
                                      data: id,
                                      flow: "new_match_txn",
                                      remName: remitterAccountDetailsData?.name,
                                    },
                                  },
                                );
                              }}
                            >
                              <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                                <Chips
                                  key={index}
                                  isDisabled={
                                    popup ||
                                    loadingState ||
                                    !hasMatchPermission ||
                                    isArchivedAccount ||
                                    isRejectAccount
                                  }
                                  txtChip={"Match transactions"}
                                  enabledBgColor="var(--primary-nav)"
                                  disableIcon={true}
                                  hoverOption="white"
                                  hoverOptionBtn="white"
                                  handleFunctionBtn={() => {
                                    if (popup) {
                                      actionRestricted();
                                    } else if (loadingState) {
                                      return;
                                    } else {
                                      if (hasMatchPermission) {
                                        if (
                                          isArchivedAccount ||
                                          isRejectAccount
                                        ) {
                                          CommonToast({
                                            text: isArchivedAccount
                                              ? "Action restricted for archived account. Unarchive it to enable this action."
                                              : "Action restricted for rejected account. Edit it to enable this action.",
                                            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                            variant: "var(--error)",
                                          });
                                        } else {
                                          navigate(
                                            "/owner_account_dashboard/consolidated_live_statement",
                                            {
                                              state: {
                                                data: id,
                                                flow: "new_match_txn",
                                                remName:
                                                  remitterAccountDetailsData?.name,
                                                // type: "remitter_details",
                                              },
                                            },
                                          );
                                        }
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "AMapping",
                                          },
                                        });
                                      }
                                    }
                                  }}
                                  enabledTextColor="var(--text-primary)"
                                />
                              </div>
                            </CommonContainerCard>
                          </div>
                        </>
                      ) : !hasLiveStatementPermission ? (
                        <>
                          <div className="w-full mx-margin-md max-w-tab-width-normal x-padding-md Qsmd:px-padding-base  Qsmd:mx-auto my-margin-md">
                            {" "}
                            <div className=" bg-primary-card p-padding-md rounded-border-radius-md">
                              <p className="  text-font-sm font-normal text-text-primary  ">
                                Service not assigned to your role.
                              </p>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          {" "}
                          <div className=" flex-1">
                            {" "}
                            <div
                              className={`absolute top-top-base z-z-index-fixed-ui h-height-full w-width-full flex justify-center items-center`}
                            >
                              <Loader />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
              {((index === GlobalConfiguration.lengthCheckZero &&
                consolidatedPaginationData?.statement?.length >
                  GlobalConfiguration.lengthCheckZero) ||
                (index === GlobalConfiguration.lengthCheckOne &&
                  livePaginationData?.ecollection_callbacks?.length >
                    GlobalConfiguration.lengthCheckZero)) && (
                <div
                  style={{
                    zIndex: "var(--z-index-fixed-ui)",
                    width: "var(--width-full)",
                    bottom: "var(--bottom-base)",
                  }}
                  className={`  ${popup ? "absolute" : "fixed"} w-width-full h-pagination-height`}
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={
                      index === GlobalConfiguration.lengthCheckZero
                        ? selectedValue
                        : selectedLiveValue
                    }
                    data={
                      index === GlobalConfiguration.lengthCheckZero
                        ? consolidatedPaginationData
                        : livePaginationData
                    }
                    pageSize={PaginationConfiguration.paginationSmall}
                    dropdownOptions={PaginationConfiguration.paginationOptions}
                    handlePagination={handlePagination}
                    currentPage={
                      index === GlobalConfiguration.lengthCheckOne
                        ? livecurrentPage
                        : currentPage
                    }
                    setIsOpen={() => {}}
                  />
                </div>
              )}
            </div>
            {((index === GlobalConfiguration.lengthCheckZero &&
              consolidatedPaginationData?.statement?.length >
                GlobalConfiguration.lengthCheckZero) ||
              (index === GlobalConfiguration.lengthCheckOne &&
                livePaginationData?.ecollection_callbacks?.length >
                  GlobalConfiguration.lengthCheckZero)) && (
              <div className="h-pagination-height"></div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default RemitterAccountDetails;
